(function() {

	$( 'form' ).attr( 'autocomplete', 'off' );

	var themes = [
		{
			sku: 'TRX-THM-000',
			name: 'Standard',
			class: 'theme-standard'
		},
		{
			sku: 'TRX-THM-004',
			name: 'Baby',
			class: 'theme-baby'
		},
		{
			sku: 'TRX-THM-017',
			name: 'Blue Streaks',
			class: 'theme-blue-streaks'
		},
		{
			sku: 'TRX-THM-016',
			name: 'Blur',
			class: 'theme-blur'
		},
		{
			sku: 'TRX-THM-005',
			name: 'Celebration',
			class: 'theme-celebration'
		},
		{
			sku: 'TRX-THM-006',
			name: 'Children',
			class: 'theme-children'
		},
		{
			sku: 'TRX-THM-022',
			name: 'Christmas',
			class: 'theme-christmas'
		},
		{
			sku: 'TRX-THM-027',
			name: 'Dog',
			class: 'theme-dog'
		},
		{
			sku: 'TRX-THM-018',
			name: 'Family History',
			class: 'theme-family-history'
		},
		{
			sku: 'TRX-THM-007',
			name: 'Inspirations',
			class: 'theme-inspirations'
		},
		{
			sku: 'TRX-THM-019',
			name: 'Movie Night',
			class: 'theme-movie-night'
		},
		{
			sku: 'TRX-THM-020',
			name: 'Movie Stars',
			class: 'theme-movie-stars'
		},
		{
			sku: 'TRX-THM-009',
			name: 'Paradise',
			class: 'theme-paradise'
		},
		{
			sku: 'TRX-THM-021',
			name: 'Scrapbook',
			class: 'theme-scrapbook'
		},
		{
			sku: 'TRX-THM-008',
			name: 'Wedding',
			class: 'theme-wedding'
		},
		{
			sku: 'TRX-THM-023',
			name: 'Winter Snow',
			class: 'theme-winter-snow'
		}
	];

	var music = [
		{
			sku: 'MIS-BMU-NOM',
			name: 'No Music',
			class: 'music-no-music',
			preview: ''
		},
		{
			sku: 'MIS-BMU-BBY',
			name: 'Baby',
			class: 'music-baby',
			preview: 'https://d1rbse7yst4ks0.cloudfront.net/catalog/MIS-BMU-BBY/music-sm.mp3'
		},
		{
			sku: 'MIS-BMU-BBA',
			name: 'Big Band',
			class: 'music-big-band',
			preview: 'https://d1rbse7yst4ks0.cloudfront.net/catalog/MIS-BMU-BBA/music-sm.mp3'
		},
		{
			sku: 'MIS-BMU-CEL',
			name: 'Celebration',
			class: 'music-celebration',
			preview: 'https://d1rbse7yst4ks0.cloudfront.net/catalog/MIS-BMU-CEL/music-sm.mp3'
		},
		{
			sku: 'MIS-BMU-CHD',
			name: 'Children',
			class: 'music-children',
			preview: 'https://d1rbse7yst4ks0.cloudfront.net/catalog/MIS-BMU-CHD/music-sm.mp3'
		},
		{
			sku: 'MIS-BMU-CLA',
			name: 'Classical',
			class: 'music-classical',
			preview: 'https://d1rbse7yst4ks0.cloudfront.net/catalog/MIS-BMU-CLA/music-sm.mp3'
		},
		{
			sku: 'MIS-BMU-COU',
			name: 'Country',
			class: 'music-country',
			preview: 'https://d1rbse7yst4ks0.cloudfront.net/catalog/MIS-BMU-COU/music-sm.mp3'
		},
		{
			sku: 'MIS-BMU-ROC',
			name: 'Rock N Roll',
			class: 'music-rock-n-roll',
			preview: 'https://d1rbse7yst4ks0.cloudfront.net/catalog/MIS-BMU-ROC/music-sm.mp3'
		},
		{
			sku: 'MIS-BMU-JAZ',
			name: 'Smooth Jazz',
			class: 'music-smooth-jazz',
			preview: 'https://d1rbse7yst4ks0.cloudfront.net/catalog/MIS-BMU-JAZ/music-sm.mp3'
		},
		{
			sku: 'MIS-BMU-HAW',
			name: 'Tropical Paradise',
			class: 'music-paradise',
			preview: 'https://d1rbse7yst4ks0.cloudfront.net/catalog/MIS-BMU-HAW/music-sm.mp3'
		},
		{
			sku: 'MIS-BMU-WED',
			name: 'Wedding',
			class: 'music-wedding',
			preview: 'https://d1rbse7yst4ks0.cloudfront.net/catalog/MIS-BMU-WED/music-sm.mp3'
		},
		{
			sku: 'MIS-BMU-WHD',
			name: 'Winter Holiday',
			class: 'music-winter-holiday',
			preview: 'https://d1rbse7yst4ks0.cloudfront.net/catalog/MIS-BMU-WHD/music-sm.mp3'
		}
	];

	$( '.cancel-additional-usb' ).on( 'click', function() {

		$( '#usb-quantity' ).val( $( '#usb-quantity' ).data( 'initial' ) );
		$( '.additional-usb-indicator' ).html( 'You currently have <strong>' + $( '#usb-quantity' ).data( 'initial' ) + '</strong> USB' + ( $( '#usb-quantity' ).data( 'initial' ) > 1 ? 's' : '' ) + ' in your cart.' );
		$( '#usb-quantity' ).change();

	});

	$( '#usb-save-additonal-button' ).on( 'click', function() {

		$( '.additional-usb-indicator' ).html( 'You currently have <strong>' + $( '#usb-quantity' ).val() + '</strong> USB' + ( $( '#usb-quantity' ).val() > 1 ? 's' : '' ) + '</strong> in your cart.' );

	});

  var updateAlbumQuantity = function () {
    var amount = document.getElementById('input-quantity').value;
    document.getElementById('albumsQuantity').value = amount;
    // console.log(amount);

    // get current album steppers
    var currentSteppers = $(".album-stepper-row");
    var currentRows = currentSteppers.length;

    if (currentRows > amount) {
      // shave off last rows
      for(let i = 1; i <=  currentRows - amount; i+=1){
        $('#album-stepper').children().last().remove();
      }
    } else if (currentRows < amount) {
      // add more (album - currnet album) album stepper rows
      for(let i = 1; i <= amount - currentRows; i+=1){
        $('#album-stepper').append(
          albumStepperHtml(i+currentRows) // index start after any currentRows
        );
      } // for
    } // if
  }; // end function

  var albumStepperHtml = function(i) {
    return '<div class="mb-6 album-stepper-row">' +
      '<div class="grid grid-cols-12">' +
          '<div class="col-span-6">' +
              '<label for="album-' + i +'" class="text-xl font-roboto font-medium"># of Photos in Album ' + i + '</label>' +
          '</div>' +
          '<div class="col-span-6">' +
              '<div class="input-quantity flex items-center justify-end w-full">' +
'<button ' +
              'class="input-quantity-stepper minus bg-center bg-no-repeat bg-contain text-[0px] w-[30px] h-[30px] mr-5 super-test" ' +
              'data-target="album-' + i +'" ' +
              'type="button" ' +
              'id="input-quantity-stepper-album-minus-' + i + '" ' +
'style="background-image: url(//costco-staging.capture.com/cdn/shop/t/5/assets/icon-remove.svg?v=57382101080464117251702582510)" ' +
          '>' +
              'Minus One'+
          '</button>' +
                  '<input ' +
                      'id="album-' + i +'" ' +
                      'type="number" ' +
                      'name="properties[album][photos_'+i+']" ' +
                      'min="1" ' +
                      'max="5000" ' +
'class="album-input ' + i + '-album js-total-album js-total-album-input super-test border border-solid border-google-gray-dark text-lg leading-none w-[75px] h-[38px] text-center rounded-sm" ' +
                      'data-increment="1" ' +
                      'value="1" ' +
                  '/>' +
'<button ' +
  'class="input-quantity-stepper plus bg-center bg-no-repeat bg-contain text-[0px] w-[30px] h-[30px] mr-5 super-test" ' +
  'data-target="album-' + i +'" ' +
  'type="button" ' +
  'id="input-quantity-stepper-album-plus-' + i + '" ' +
  'style="margin-left: 20px; background-image: url(//costco-staging.capture.com/cdn/shop/t/5/assets/icon-add.svg?v=70240443208336596661702582517)" ' +
'>' +
'Plus'+
'</button>' +

'</div>' +
'</div>' +
'</div>' +
    '</div>' ;
  };
	var preloadProduct = function( product ) {

		if( $( '.images-transfer-form' ).length > 0 ) {

			$( 'input[name="quantity"]' ).val( product.properties.data.value.quantity );

		} else {

			$( 'input[name="quantity"]' ).val( product.quantity );

		}

		$( 'input[name="properties[dvd][quantity]"]' ).val( parseInt( product?.properties?.data?.value?.dvd_copies ) );

		if( $( 'input[name="properties[dvd][quantity]"]' ).val() > 0 ) {

			$( '.js-dvd-extra' ).removeClass( 'hidden' );

		}

		$( 'input[name="properties[dvd][theme]"]' ).each( function() {

			$( 'input[name="properties[dvd][theme]"]' ).prop( 'checked', false );

		});

		$( 'input[name="properties[dvd][theme]"]' ).each( function() {

			if( $( this ).val() === product.properties.data.value.dvd_options.theme ) {

				$( this ).prop( 'checked', true );

				$.each( themes, function( index, item ) {

					if(  item.sku === product.properties.data.value.dvd_options.theme ) {

						$( '.input-dvd-extra-theme-title' ).html( item.name );

						$( '.input-dvd-off-canvas-customizer-inner-theme-image' ).attr( 'class', 'my-5 mx-auto relative max-w-[350px] bg-contain bg-center bg-no-repeat before:w-full before:pt-[70%] before:block input-dvd-off-canvas-customizer-inner-theme-image ' + item.class );

					}

				});

			}

		});

		$( 'input[name="properties[dvd][music]"]' ).each( function() {

			$( 'input[name="properties[dvd][music]"]' ).prop( 'checked', false );

		});

		$( 'input[name="properties[dvd][music]"]' ).each( function() {

			if( $( this ).val() === product.properties.data.value.dvd_options.music ) {

				$( this ).prop( 'checked', true );

				$.each( music, function( index, item ) {

					if(  item.sku === product.properties.data.value.dvd_options.music ) {

						$( '.input-dvd-extra-music-title' ).html( item.name );

					}

				});

			}

		});

		$( 'input[name="properties[title]"]' ).val( product?.properties?.data?.value?.customizations?.[ 0 ].title );

		if( product.properties.data.value.customizations[ 0 ].media_date ) {

			let dateArray = product.properties.data.value.customizations[ 0 ].media_date.split( '/' );

			$( 'input[name="properties[year]"]' ).val( dateArray[ 0 ] );
			$( 'input[name="properties[month]"]' ).val( dateArray[ 1 ] );
			$( 'input[name="properties[day]"]' ).val( dateArray[ 2 ] );

		}

		$( '.loader' ).toggleClass( 'active' );

	}

	var preloadFilmProduct = function( product ) {

		var reelInputs  = $( '.reel-input' );

		$.each( product.properties.data.value.customizations, function( index, value ) {

			$( reelInputs[ index ] ).val( value.quantity );

		});


		$( 'input[name="properties[dvd][quantity]"]' ).val( parseInt( product?.properties?.data?.value?.dvd_copies ) );

		if( $( 'input[name="properties[dvd][quantity]"]' ).val() > 0 ) {

			$( '.js-dvd-extra' ).removeClass( 'hidden' );

		}

		$( 'input[name="properties[dvd][theme]"]' ).each( function() {

			$( 'input[name="properties[dvd][theme]"]' ).prop( 'checked', false );

		});

		$( 'input[name="properties[dvd][theme]"]' ).each( function() {

			if( $( this ).val() === product.properties.data.value.dvd_options.theme ) {

				$( this ).prop( 'checked', true );

				$.each( themes, function( index, item ) {

					if(  item.sku === product.properties.data.value.dvd_options.theme ) {

						$( '.input-dvd-extra-theme-title' ).html( item.name );

						$( '.input-dvd-off-canvas-customizer-inner-theme-image' ).attr( 'class', 'my-5 mx-auto relative max-w-[350px] bg-contain bg-center bg-no-repeat before:w-full before:pt-[70%] before:block input-dvd-off-canvas-customizer-inner-theme-image ' + item.class );

					}

				});

			}

		});

		$( 'input[name="properties[dvd][music]"]' ).each( function() {

			$( 'input[name="properties[dvd][music]"]' ).prop( 'checked', false );

		});

		$( 'input[name="properties[dvd][music]"]' ).each( function() {

			if( $( this ).val() === product.properties.data.value.dvd_options.music ) {

				$( this ).prop( 'checked', true );

				$.each( music, function( index, item ) {

					if(  item.sku === product.properties.data.value.dvd_options.music ) {

						$( '.input-dvd-extra-music-title' ).html( item.name );

					}

				});

			}

		});

		$( 'input[name="properties[title]"]' ).val( product?.properties?.data?.value?.title );

		if( product.properties.data.value.media_date ) {

			let dateArray = product.properties.data.value.media_date.split( '/' );

			$( 'input[name="properties[year]"]' ).val( dateArray[ 0 ] );
			$( 'input[name="properties[month]"]' ).val( dateArray[ 1 ] );
			$( 'input[name="properties[day]"]' ).val( dateArray[ 2 ] );

		}

		if( product.properties.data.value.actual_audio == true ) {

			$( '.input-original-audio-details' ).prop( 'checked', true );

			$( '.music-option-radio-wrapper' ).each( function() {

				$( this ).addClass( 'disabled' );

			});

			$( ".input-audio-message" ).removeClass( 'hidden' );

			$( ".drawer-input-audio-message" ).html( "Music is unavailable with Original Audio." );

			$( ".drawer-input-audio-message" ).css( "font-size", "14px" );

			$( '.input-dvd-extra-music-title' ).html( 'Original Audio' );

		}

		$( '.loader' ).toggleClass( 'active' );

	}

	var preloadAlbumProduct = function( product ) {
		var albumInputs  = $( '.album-input' );

		$.each( product.properties.data.value.customizations, function( index, value ) {
			$( albumInputs[ index ] ).val( value.quantity );

		});

		$( 'input[name="properties[dvd][quantity]"]' ).val( parseInt( product?.properties?.data?.value?.dvd_copies ) );

		if( $( 'input[name="properties[dvd][quantity]"]' ).val() > 0 ) {

			$( '.js-dvd-extra' ).removeClass( 'hidden' );

		}

		$( 'input[name="properties[dvd][theme]"]' ).each( function() {

			$( 'input[name="properties[dvd][theme]"]' ).prop( 'checked', false );

		});

		$( 'input[name="properties[dvd][theme]"]' ).each( function() {

			if( $( this ).val() === product.properties.data.value.dvd_options.theme ) {

				$( this ).prop( 'checked', true );

				$.each( themes, function( index, item ) {

					if(  item.sku === product.properties.data.value.dvd_options.theme ) {

						$( '.input-dvd-extra-theme-title' ).html( item.name );

						$( '.input-dvd-off-canvas-customizer-inner-theme-image' ).attr( 'class', 'my-5 mx-auto relative max-w-[350px] bg-contain bg-center bg-no-repeat before:w-full before:pt-[70%] before:block input-dvd-off-canvas-customizer-inner-theme-image ' + item.class );

					}

				});

			}

		});

		$( 'input[name="properties[dvd][music]"]' ).each( function() {

			$( 'input[name="properties[dvd][music]"]' ).prop( 'checked', false );

		});

		$( 'input[name="properties[dvd][music]"]' ).each( function() {

			if( $( this ).val() === product.properties.data.value.dvd_options.music ) {

				$( this ).prop( 'checked', true );

				$.each( music, function( index, item ) {

					if(  item.sku === product.properties.data.value.dvd_options.music ) {

						$( '.input-dvd-extra-music-title' ).html( item.name );

					}

				});

			}

		});

		$( '.loader' ).toggleClass( 'active' );

	}

	var calculateTotal = function() {

		var quantity = parseInt( $( '#input-quantity' ).val() );
		var baseAmount = parseInt( $( '#input-quantity' ).data( 'baseAmount' ) );
		var increment = parseInt( $( '#input-quantity' ).data( 'increment' ) );
		var additionalIncrement = parseInt( $( '#input-quantity' ).data( 'additionalIncrement' ) )
		var total;

		if( quantity === 0 ) {

			$( '.js-' ).prop( 'disabled', true );

			$( 'input[name="properties[estimated-total]"]' ).val( 0 );
			$( 'input[name="properties[estimated-additional-total]"]' ).val( 0 );

			total = 0;

		} else {

			$( '.js-button-add-to-cart' ).prop( 'disabled', false );

			if( quantity > baseAmount ) {

				total = increment + ( additionalIncrement * ( quantity - baseAmount ) );

				$( 'input[name="properties[estimated-total]"]' ).val( increment );

				$( 'input[name="properties[estimated-additional-total]"]' ).val( additionalIncrement * ( quantity - baseAmount ) );

			} else {

				total = increment;

				$( 'input[name="properties[estimated-total]"]' ).val( increment );
				$( 'input[name="properties[estimated-additional-total]"]' ).val( 0 );

			}

		}

		$( '.js-total' ).each( function() {

			if( $( this ).hasClass( 'js-total-usb' ) ) {

				if( parseInt( $( this ).val() ) > parseInt( $( this ).data( 'initial' ) ) ) {

					$( 'input[name="properties[usb-total]"]' ).val( ( $( this ).val() - $( this ).data( 'initial' ) ) * $( this ).data( 'increment' ) );

				} else {

					$( 'input[name="properties[usb-total]"]' ).val( 0 );

				}

			}

			if( $( this ).hasClass( 'js-total-dvd' ) ) {

				if( $( this ).val() > 0 ) {

					$( '.js-dvd-extra' ).removeClass( 'hidden' );

				} else {

					if( ! $( '.js-dvd-extra' ).hasClass( 'hidden' ) ) {

						$( '.js-dvd-extra' ).addClass( 'hidden' );

					}

				}

				if( $( '.video-transfer-form' ).length > 0 ) {


					$( 'input[name="properties[dvd-total]"]' ).val( ( $( this ).val() * $( this ).data( 'increment' ) ) * quantity );

					var dvdTerm = quantity > 1 ? 'copy' : 'copy';

					if( $( this ).data( 'discount' ) > 0 ) {

						$( '.input-dvd-description' ).html( '<strong>+<ins class="no-underline">$' + ( ( ( $( this ).data( 'increment' ) * quantity ) / 100 ).toFixed( 2 ) ) + '<ins></strong> <del>$' +  ( ( ( $( this ).data( 'discount' ) * quantity ) / 100 ).toFixed( 2 ) ) + '</del> per ' + ' ' + dvdTerm);

					} else {

						$( '.input-dvd-description' ).html( '<strong>+$' + ( ( ( $( this ).data( 'increment' ) * quantity ) / 100 ).toFixed( 2 ) ) + '</strong> per ' + ' ' + dvdTerm);

					}

				} else if ( $( '.digital-transfer-form' ).length > 0 ) {


					$( 'input[name="properties[dvd-total]"]' ).val( ( $( this ).val() * $( this ).data( 'increment' ) ) * quantity );

					var dvdTerm = quantity > 1 ? 'copy' : 'copy';

					if( $( this ).data( 'discount' ) > 0 ) {

						$( '.input-dvd-description' ).html( '<strong>+<ins class="no-underline">$' + ( ( ( $( this ).data( 'increment' ) * quantity ) / 100 ).toFixed( 2 ) ) + '<ins></strong> <del>$' +  ( ( ( $( this ).data( 'discount' ) * quantity ) / 100 ).toFixed( 2 ) ) + '</del> per ' + ' ' + dvdTerm);

					} else {

						$( '.input-dvd-description' ).html( '<strong>+$' + ( ( ( $( this ).data( 'increment' ) * quantity ) / 100 ).toFixed( 2 ) ) + '</strong> per ' +' ' + dvdTerm);

					}

        } else if ( $( '.album-transfer-form' ).length > 0 ) {

          // dvd total will be recalculated by calculateAlbumTotal, so this here will be overridden
					$( 'input[name="properties[dvd-total]"]' ).val( ( $( this ).val() * $( this ).data( 'increment' ) ) * quantity );

          // text changes here to the description is needed here, since calculateAlbumTotal doesn't do it.
					var dvdTerm = quantity > 1 ? 'copy' : 'copy';

					if( $( this ).data( 'discount' ) > 0 ) {

						$( '.input-dvd-description' ).html( '<strong>+<ins class="no-underline">$' + ( ( ( $( this ).data( 'increment' ) * quantity ) / 100 ).toFixed( 2 ) ) + '<ins></strong> <del>$' +  ( ( ( $( this ).data( 'discount' ) * quantity ) / 100 ).toFixed( 2 ) ) + '</del> per ' + ' ' + dvdTerm);

					} else {

						$( '.input-dvd-description' ).html( '<strong>+$' + ( ( ( $( this ).data( 'increment' ) * quantity ) / 100 ).toFixed( 2 ) ) + '</strong> per ' + ' ' + dvdTerm);

					}

				} else {

					$( 'input[name="properties[dvd-total]"]' ).val( $( this ).val() * $( this ).data( 'increment' ) );

				}


			}

		});

		total = total + parseInt( $( 'input[name="properties[usb-total]"]' ).val() ) + parseInt( $( 'input[name="properties[dvd-total]"]' ).val() );

		$( '.product-estimated-total' ).html( '$' + ( ( total / 100 ).toFixed( 2 ) ) );

	}

	var calculateFilmTotal = function () {

		var baseAmount = 100;
		var totalFeetCount = 0;
		var totalReelCount = 0;
		var baseCost = $( '.js-film-input-container' ).data( 'increment' );
		var additionalCost = $( '.js-film-input-container' ).data( 'additionalIncrement' );


		$( '.js-total-film.js-total-feet-input' ).each( function () {

			if( $( this ).val() > 0 ) {

				let feetPerRoll = parseInt( $( this ).val() ) * $( this ).data( 'increment' );
				totalReelCount = totalReelCount + parseInt( $( this ).val() );

				totalFeetCount = totalFeetCount + feetPerRoll;

			}

		});

		$( '.js-reel-count-badge' ).html( totalReelCount );
		$( '.js-feet-count-badge' ).html( totalFeetCount );

		var total;


		if( totalFeetCount - baseAmount > 0 ) {

			total = baseCost + ( additionalCost * ( totalFeetCount - baseAmount ) );

			$( 'input[name="properties[estimated-total]"]' ).val( baseCost );
			$( 'input[name="properties[estimated-additional-total]"]' ).val( total - baseCost );

		} else {

			total = baseCost;

			$( 'input[name="properties[estimated-total]"]' ).val( baseCost );
			$( 'input[name="properties[estimated-additional-total]"]' ).val( 0 );

		}

		$( '.js-total-film' ).each( function() {

			if( $( this ).hasClass( 'js-total-usb' ) ) {

				if( parseInt( $( this ).val() ) > parseInt( $( this ).data( 'initial' ) ) ) {

					$( 'input[name="properties[usb-total]"]' ).val( ( $( this ).val() - $( this ).data( 'initial' ) ) * $( this ).data( 'increment' ) );

				} else {

					$( 'input[name="properties[usb-total]"]' ).val( 0 );

				}

			}

			if( $( this ).hasClass( 'js-total-dvd' ) ) {

				if( $( this ).val() > 0 ) {

					$( '.js-dvd-extra' ).removeClass( 'hidden' );

				} else {

					if( ! $( '.js-dvd-extra' ).hasClass( 'hidden' ) ) {

						$( '.js-dvd-extra' ).addClass( 'hidden' );

					}

				}

				$( 'input[name="properties[dvd-total]"]' ).val( $( this ).val() * $( this ).data( 'increment' ) );

			}

		});

		total = total + parseInt( $( 'input[name="properties[usb-total]"]' ).val() ) + parseInt( $( 'input[name="properties[dvd-total]"]' ).val() );

		$( '.product-estimated-total' ).html( '$' + ( ( total / 100 ).toFixed( 2 ) ) );

		if( totalFeetCount > 0 ) {

			$( '.js-add-to-cart-film' ).attr( 'disabled', false );

		}

	}

	var calculateAlbumTotal = function () {
		var quantity = parseInt( $( '#input-quantity' ).val() );
    // console.log('quantity: ' + quantity);
		var baseAmount = 35;
		var totalPhotoCount = 0;
		var baseCost = $( '.js-album-input-container' ).data( 'increment' );
		var additionalCost = $( '.js-album-input-container' ).data( 'additionalIncrement' );

        var total = 0;
        var totalEstimated = 0;
        var totalAdditionalEstimated = 0;

		$( '.js-total-album.js-total-album-input' ).each( function () {

			if( $( this ).val() > 0 ) {

				totalPhotoCount += parseInt( $( this ).val() ) * $( this ).data( 'increment' );

                totalEstimated += baseCost;

                if( $( this ).val() > 35 ) {
                  totalAdditionalEstimated += additionalCost * ($( this ).val() - 35);
                }

			}

		});

		$( '.js-total-album' ).each( function() {

			if( $( this ).hasClass( 'js-total-usb' ) ) {

				if( parseInt( $( this ).val() ) > parseInt( $( this ).data( 'initial' ) ) ) {

					$( 'input[name="properties[usb-total]"]' ).val( ( $( this ).val() - $( this ).data( 'initial' ) ) * $( this ).data( 'increment' ) );

				} else {

					$( 'input[name="properties[usb-total]"]' ).val( 0 );

				}

			}

			if( $( this ).hasClass( 'js-total-dvd' ) ) {

				if( $( this ).val() > 0 ) {

					$( '.js-dvd-extra' ).removeClass( 'hidden' );

				} else {

					if( ! $( '.js-dvd-extra' ).hasClass( 'hidden' ) ) {

						$( '.js-dvd-extra' ).addClass( 'hidden' );

					}

				}
        // TODO
				$( 'input[name="properties[dvd-total]"]' ).val( ( $( this ).val() * $( this ).data( 'increment' ) ) * quantity );

				var dvdTerm = quantity > 1 ? 'copy' : 'copy';

				if( $( this ).data( 'discount' ) > 0 ) {

					$( '.input-dvd-description' ).html( '<strong>+<ins class="no-underline">$' + ( ( ( $( this ).data( 'increment' ) * quantity ) / 100 ).toFixed( 2 ) ) + '<ins></strong> <del>$' +  ( ( ( $( this ).data( 'discount' ) * quantity ) / 100 ).toFixed( 2 ) ) + '</del> per ' + dvdTerm);

				} else {

					$( '.input-dvd-description' ).html( '<strong>+$' + ( ( ( $( this ).data( 'increment' ) * quantity ) / 100 ).toFixed( 2 ) ) + '</strong> per ' + dvdTerm);

				}

			}

		});

		total = total + parseInt( $( 'input[name="properties[usb-total]"]' ).val() ) + parseInt( $( 'input[name="properties[dvd-total]"]' ).val() );

        // if( totalPhotoCount - baseAmount > 0 ) {
        if( quantity > 0 ) {

			total += totalEstimated + totalAdditionalEstimated;

			$( 'input[name="properties[estimated-total]"]' ).val( totalEstimated );
			$( 'input[name="properties[estimated-additional-total]"]' ).val( totalAdditionalEstimated );

		} else {

			$( 'input[name="properties[estimated-total]"]' ).val( 0 );
			$( 'input[name="properties[estimated-additional-total]"]' ).val( 0 );

		}

		$( '.product-estimated-total' ).html( '$' + ( ( total / 100 ).toFixed( 2 ) ) );

		if( quantity > 0 ) {
        	$( '.js-add-to-cart-album' ).attr( 'disabled', false );
		}else{
            $( '.js-add-to-cart-album' ).attr( 'disabled', true );
        }

	}

	var searchParams = new URLSearchParams( window.location.search );

	if( searchParams.has( 'edit' ) ) {

		$( '.loader' ).toggleClass( 'active' );

		$.ajax({
			url : '/cart.js',
			type : 'GET',
			dataType: 'json',
			success : function( res ) {
				if( $( '.film-transfer-form' ).length > 0 ) {

					// get main product values
					product = res.items.find( function( item ){ return item.key == searchParams.get( 'edit' ) });

					$.when( preloadFilmProduct( product ) ).then(function(){

						calculateFilmTotal();

					});
        } else if( $( '.album-transfer-form' ).length > 0 ) {

					// get main product values

					product = res.items.find( function( item ){ return item.key == searchParams.get( 'edit' ) });


                    $( '#input-quantity' ).val(product.quantity);
                    updateAlbumQuantity();
                  var dvdTerm = product.quantity > 1 ? 'copy' : 'copy';
                  // console.log('holaxyz: ' + (((product.properties.upsells.dvd.total/product.quantity)/100).toFixed(2)));
                  $( '.input-dvd-description' ).html( '<strong>+$' + (((product.properties.upsells.dvd.total/product.quantity)/100).toFixed(2)) + '</strong> for ' + product.quantity + ' ' + dvdTerm);


					$.when( preloadAlbumProduct( product ) ).then(function(){

						calculateAlbumTotal();
					});

				} else {

					// get main product values
					product = res.items.find( function( item ){ return item.key == searchParams.get( 'edit' ) });


					$.when( preloadProduct( product ) ).then(function(){

						calculateTotal();

					});

			  }

			},
			error : function( error ){
				console.log( error )
				alert( 'Sorry an error occurred.' );

			}
		});

	} else {
	  // regular load without edit
    if( $( '.album-transfer-form' ).length > 0 ) {
      updateAlbumQuantity();
    }
	}
	$( document ).on( 'click', '.input-quantity-stepper.plus', function( event ) {

		event.preventDefault();

		var targetInput = $( this ).attr( 'data-target' );

		if( $.isNumeric( $( '#' + targetInput ).val() ) ) {

			if( ( parseInt( $( '#' + targetInput ).val() ) + 1 ) <= parseInt( $( '#' + targetInput ).attr( 'max' ) ) ) {

				$( '#' + targetInput ).val( parseInt( $( '#' + targetInput ).val() ) + 1 );

			} else {

				window.theme.functions.triggerAlert( 'Maximum quantity for this input is ' + $( '#' + targetInput ).attr( 'max' ), 'error' );

			}

		} else {

			$( '#' + targetInput ).val( 1 );

		}

		$( '#' + targetInput ).change();

	});

	$( document ).on( 'click', '.input-quantity-stepper.minus', function( event ) {

		event.preventDefault();

		var targetInput = $( this ).attr( 'data-target' );


		if( $.isNumeric( $( '#' + targetInput ).val() ) ) {

			// if ( parseInt( $( '#' + targetInput ).val() ) - 1 <= 0) {
            if( ( parseInt( $( '#' + targetInput ).val() ) - 1 ) < parseInt( $( '#' + targetInput ).attr( 'min' ) ) ) {

                window.theme.functions.triggerAlert( 'Minimum quantity for this input is ' + $( '#' + targetInput ).attr( 'min' ), 'error' );
				// $( '#' + targetInput ).val( 0 );

			} else {

				$( '#' + targetInput ).val( parseInt( $( '#' + targetInput ).val() ) - 1 );

			}

		} else {

			$( '#' + targetInput ).val( 0 );

		}

		$( '#' + targetInput ).change();

	});

	//general product calculations

	$( '.js-total' ).on( 'change', function() {

		calculateTotal();

	});

	//film total calculation
	$( '.js-total-film' ).on( 'change', function() {

		calculateFilmTotal();

	});



  //album total calculation
    $( '.js-total-album.album-quantity' ).on( 'change', function() {
      updateAlbumQuantity();
    });

    $( '#album-stepper' ).on( 'change', function() {
		calculateAlbumTotal();
	});


	$( '.js-total-album' ).on( 'change', function() {
		calculateAlbumTotal();
	});

	$( document ).on( 'keydown', 'input[type="number"]', function( event ) {



		var invalidChars = [
			"-",
			"_",
			"+",
			"e",
			"E",
			'.'
		];

		if ( invalidChars.includes( event.key ) ) {

			event.stopPropagation()
			event.preventDefault();

		}

	});

	$( document ).on( 'input', 'input[type="number"]', function( event ) {

		if( ! $( this ).hasClass( 'js-date-input' ) ) {

			var max = parseInt( this.max );

			var min = parseInt( this.min );

			if( parseInt( this.value ) > max ) {

				if( !$( this ).hasClass( 'js-year-input' ) && !$( this ).hasClass( 'js-day-input' ) && !$( this ).hasClass( 'js-month-input') ) {

					this.value = max;

					window.theme.functions.triggerAlert( 'Maximum quantity for this input is ' + max, 'error' );

				}

			}

			if( parseInt( this.value ) <= min ) {

				if( !$( this ).hasClass( 'js-year-input' ) && !$( this ).hasClass( 'js-day-input' ) && !$( this ).hasClass( 'js-month-input') ) {

					this.value = min;

				}

			}

			$( this ).change();

		}

	});

	var triggerTapeCustomizer = function() {

		//clears all form elements at render to ensure only the right elements are shown
		$( '.tape-selector-wrappers' ).html( '' );
		$( '.off-canvas-tape-customizer-inputs' ).html( '' );
		$( '.off-canvas-tape-customizer-actions' ).html( '' );

		//renders out buttons for how many tapes were selected
		for( var i = 0; i < $( 'input[name="quantity"]' ).val(); i++ ) {

			if( i === 0 ) {

				$( '.tape-selector-wrappers' ).append( '<button type="button" class="tape-customizer-select active" aria-label="Open tape ' + i + ' form" id="tape-' + i + '" >' + ( i + 1 ) + '</button>' );

			} else {

				if( searchParams.has( 'edit' ) ) {

					$( '.tape-selector-wrappers' ).append( '<button type="button" class="tape-customizer-select" aria-label="Open tape ' + i + ' form" id="tape-' + i + '" >' + ( i + 1 ) + '</button>' );

				} else {

					$( '.tape-selector-wrappers' ).append( '<button disabled type="button" class="tape-customizer-select" aria-label="Open tape ' + i + ' form" id="tape-' + i + '" >' + ( i + 1 ) + '</button>' );

				}

			}

		}

		for( var i = 0; i < $( 'input[name="quantity"]' ).val(); i++ ) {

			if( searchParams.has( 'edit' ) ) {

				if( product.properties.data.value.customizations[ i ] ) {

					let dateArray = product.properties.data.value.customizations[ i ]?.media_date?.split( '/' );

					let year;
					let month;
					let day;

					if( dateArray ) {

						year = dateArray[ 0 ] ;
						month = dateArray[ 1 ];
						day = dateArray[ 2 ];

					} else {

						year = '';
						month = '';
						day = '';

					}

					let rewindStatus = product.properties.data.value.customizations[ i ].rewind
					let rewindString;

					if ( rewindStatus == true ) {

						rewindString = '<option value="true" selected>Yes, please rewind tape</option><option value="false">No, do not rewind tape</option>';

					} else {

						rewindString = '<option value="true">Yes, please rewind tape</option><option value="false" selected>No, do not rewind tape</option>';

					}

					$( '.off-canvas-tape-customizer-inputs' ).append(
						'<div class="tape-customizer-single-form ' + ( i === 0 ? '' : 'hidden' ) + '" id="tape-customizer-form-' + i + '">' +
						'<div class="flex items-center mb-2.5">' +
						'<label for="tape-' + i + '-title" class="text-xl font-medium mr-1 text-black">Album Title</label>' +
						'<div class="tooltip">' +
						'<div class="tooltip-icon" tabindex="0"><svg width="20" height="21" viewBox="0 0 20 21"><circle cx="10" cy="10.7981" r="10" fill="#4784F2"/><path d="M9.10258 15.0855V16.7505H10.7676V15.0855H9.10258ZM6.65758 9.38549H7.93258C7.93258 9.03549 7.97258 8.71049 8.05258 8.41049C8.13258 8.11049 8.25758 7.85049 8.42758 7.63049C8.60758 7.41049 8.82758 7.23549 9.08758 7.10549C9.34758 6.97549 9.65758 6.91049 10.0176 6.91049C10.5576 6.91049 10.9826 7.06549 11.2926 7.37549C11.6126 7.68549 11.7926 8.11549 11.8326 8.66549C11.8526 9.03549 11.8076 9.35049 11.6976 9.61049C11.5876 9.87049 11.4376 10.1105 11.2476 10.3305C11.0676 10.5405 10.8676 10.7455 10.6476 10.9455C10.4376 11.1355 10.2326 11.3455 10.0326 11.5755C9.84258 11.8055 9.67758 12.0705 9.53758 12.3705C9.40758 12.6605 9.33258 13.0155 9.31258 13.4355V14.1405H10.5876V13.5555C10.5876 13.2955 10.6226 13.0655 10.6926 12.8655C10.7726 12.6555 10.8726 12.4655 10.9926 12.2955C11.1226 12.1155 11.2626 11.9505 11.4126 11.8005C11.5726 11.6405 11.7326 11.4855 11.8926 11.3355C12.0526 11.1755 12.2076 11.0105 12.3576 10.8405C12.5176 10.6705 12.6576 10.4855 12.7776 10.2855C12.8976 10.0855 12.9926 9.86549 13.0626 9.62549C13.1426 9.37549 13.1826 9.09549 13.1826 8.78549C13.1826 8.30549 13.1026 7.88049 12.9426 7.51049C12.7926 7.14049 12.5776 6.83049 12.2976 6.58049C12.0176 6.32049 11.6826 6.12549 11.2926 5.99549C10.9126 5.85549 10.4876 5.78549 10.0176 5.78549C9.49758 5.78549 9.02758 5.87549 8.60758 6.05549C8.18758 6.23549 7.83258 6.49049 7.54258 6.82049C7.25258 7.14049 7.02758 7.52049 6.86758 7.96049C6.71758 8.40049 6.64758 8.87549 6.65758 9.38549Z" fill="white"/></svg></div> <div class="tooltip-content">' + window.theme.tooltips?.album_title + '</div>' +
						'</div>' +
						'</div>' +
						'<input id="tape-' + i + '-title" type="text" aria-label="Tape ' + i + ' title" name="properties[ tape-' + i + ' ][ title ]" placeholder="ex. “My Family Memories 1964”" class="p-3.5 w-full text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 tape-customizer-input title-input" maxLength="35" value="' + product.properties.data.value.customizations[ i ].title + '" />' +
						'<div class="flex items-center mb-2.5">' +
						'<label class="text-xl font-medium mr-1 text-black">Estimated Media Date</label>' +
						'<div class="tooltip">' +
						'<div class="tooltip-icon" tabindex="0"><svg width="20" height="21" viewBox="0 0 20 21"><circle cx="10" cy="10.7981" r="10" fill="#4784F2"/><path d="M9.10258 15.0855V16.7505H10.7676V15.0855H9.10258ZM6.65758 9.38549H7.93258C7.93258 9.03549 7.97258 8.71049 8.05258 8.41049C8.13258 8.11049 8.25758 7.85049 8.42758 7.63049C8.60758 7.41049 8.82758 7.23549 9.08758 7.10549C9.34758 6.97549 9.65758 6.91049 10.0176 6.91049C10.5576 6.91049 10.9826 7.06549 11.2926 7.37549C11.6126 7.68549 11.7926 8.11549 11.8326 8.66549C11.8526 9.03549 11.8076 9.35049 11.6976 9.61049C11.5876 9.87049 11.4376 10.1105 11.2476 10.3305C11.0676 10.5405 10.8676 10.7455 10.6476 10.9455C10.4376 11.1355 10.2326 11.3455 10.0326 11.5755C9.84258 11.8055 9.67758 12.0705 9.53758 12.3705C9.40758 12.6605 9.33258 13.0155 9.31258 13.4355V14.1405H10.5876V13.5555C10.5876 13.2955 10.6226 13.0655 10.6926 12.8655C10.7726 12.6555 10.8726 12.4655 10.9926 12.2955C11.1226 12.1155 11.2626 11.9505 11.4126 11.8005C11.5726 11.6405 11.7326 11.4855 11.8926 11.3355C12.0526 11.1755 12.2076 11.0105 12.3576 10.8405C12.5176 10.6705 12.6576 10.4855 12.7776 10.2855C12.8976 10.0855 12.9926 9.86549 13.0626 9.62549C13.1426 9.37549 13.1826 9.09549 13.1826 8.78549C13.1826 8.30549 13.1026 7.88049 12.9426 7.51049C12.7926 7.14049 12.5776 6.83049 12.2976 6.58049C12.0176 6.32049 11.6826 6.12549 11.2926 5.99549C10.9126 5.85549 10.4876 5.78549 10.0176 5.78549C9.49758 5.78549 9.02758 5.87549 8.60758 6.05549C8.18758 6.23549 7.83258 6.49049 7.54258 6.82049C7.25258 7.14049 7.02758 7.52049 6.86758 7.96049C6.71758 8.40049 6.64758 8.87549 6.65758 9.38549Z" fill="white"/></svg></div> <div class="tooltip-content date">' + window.theme.tooltips?.estimated_date + '</div>' +
						'</div>' +
						'</div>' +
						'<div class="flex items-center">' +
						'<label for="tape-' + i + '-year" style="opacity:0;font-size:0;margin:0">Tape Year</label>' +
						'<input id="tape-' + i + '-year" type="number" aria-label="Tape ' + i + ' year" name="properties[ tape-' + i + ' ][ year ]" placeholder="YYYY" maxLength="4" class="p-3.5 inline-block text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 w-[100px] mr-3.5 tape-customizer-input js-date-input js-year-input text-input text-center" min="1800" oninput="this.value=this.value.slice(0,this.maxLength)" value="' + year + '"/>' +
						'<label for="tape-' + i + '-month" style="opacity:0;font-size:0;margin:0">Tape Month</label>' +
						'<input id="tape-' + i + '-month" type="number" aria-label="Tape ' + i + ' month" name="properties[ tape-' + i + ' ][ month ]" placeholder="MM" min="1" max="12" maxLength="2" class="p-3.5 inline-block text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 w-[75px] mr-3.5 tape-customizer-input js-date-input js-month-input text-input text-center" maxLength="2" oninput="this.value=this.value.slice(0,this.maxLength)" value="' + month + '"/>' +
						'<label for="tape-' + i + '-day" style="opacity:0;font-size:0;margin:0">Tape Day</label>' +
						'<input id="tape-' + i + '-day" type="number" aria-label="Tape ' + i + ' day" name="properties[ tape-' + i + ' ][ day ]" placeholder="DD" maxLength="2" class="p-3.5 inline-block text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 w-[75px] mr-3.5 tape-customizer-input js-date-input js-day-input text-input text-center" max="31" min="1" oninput="this.value=this.value.slice(0,this.maxLength)" value="' + day + '"/>' +
						'</div>' +
						'<div class="mb-2.5">' +
						'<label for="tape-' + i + '-rewind-control" class="text-xl font-medium mr-1 text-black mb-2.5 block">Rewind Tape</label>' +
						'<p class="mb-6">Unless you prefer to begin from a set place, our technicians will rewind your tape to the beginning before transfer.</p>' +
						'</div>' +
						'<select id="tape-' + i + '-rewind-control" name="properties[ tape-' + i +' ][ rewind ]" class="tape-customizer-select-input">' +
						rewindString +
						'</select>'+
						'</div>'
					);

				} else {

					$( '.off-canvas-tape-customizer-inputs' ).append(
						'<div class="tape-customizer-single-form ' + ( i === 0 ? '' : 'hidden' ) + '" id="tape-customizer-form-' + i + '">' +
						'<div class="flex items-center mb-2.5">' +
						'<label for="tape-' + i + '-title" class="text-xl font-medium mr-1 text-black">Album Title</label>' +
						'<div class="tooltip">' +
						'<div class="tooltip-icon" tabindex="0"><svg width="20" height="21" viewBox="0 0 20 21"><circle cx="10" cy="10.7981" r="10" fill="#4784F2"/><path d="M9.10258 15.0855V16.7505H10.7676V15.0855H9.10258ZM6.65758 9.38549H7.93258C7.93258 9.03549 7.97258 8.71049 8.05258 8.41049C8.13258 8.11049 8.25758 7.85049 8.42758 7.63049C8.60758 7.41049 8.82758 7.23549 9.08758 7.10549C9.34758 6.97549 9.65758 6.91049 10.0176 6.91049C10.5576 6.91049 10.9826 7.06549 11.2926 7.37549C11.6126 7.68549 11.7926 8.11549 11.8326 8.66549C11.8526 9.03549 11.8076 9.35049 11.6976 9.61049C11.5876 9.87049 11.4376 10.1105 11.2476 10.3305C11.0676 10.5405 10.8676 10.7455 10.6476 10.9455C10.4376 11.1355 10.2326 11.3455 10.0326 11.5755C9.84258 11.8055 9.67758 12.0705 9.53758 12.3705C9.40758 12.6605 9.33258 13.0155 9.31258 13.4355V14.1405H10.5876V13.5555C10.5876 13.2955 10.6226 13.0655 10.6926 12.8655C10.7726 12.6555 10.8726 12.4655 10.9926 12.2955C11.1226 12.1155 11.2626 11.9505 11.4126 11.8005C11.5726 11.6405 11.7326 11.4855 11.8926 11.3355C12.0526 11.1755 12.2076 11.0105 12.3576 10.8405C12.5176 10.6705 12.6576 10.4855 12.7776 10.2855C12.8976 10.0855 12.9926 9.86549 13.0626 9.62549C13.1426 9.37549 13.1826 9.09549 13.1826 8.78549C13.1826 8.30549 13.1026 7.88049 12.9426 7.51049C12.7926 7.14049 12.5776 6.83049 12.2976 6.58049C12.0176 6.32049 11.6826 6.12549 11.2926 5.99549C10.9126 5.85549 10.4876 5.78549 10.0176 5.78549C9.49758 5.78549 9.02758 5.87549 8.60758 6.05549C8.18758 6.23549 7.83258 6.49049 7.54258 6.82049C7.25258 7.14049 7.02758 7.52049 6.86758 7.96049C6.71758 8.40049 6.64758 8.87549 6.65758 9.38549Z" fill="white"/></svg></div> <div class="tooltip-content">' + window.theme.tooltips?.album_title + '</div>' +
						'</div>' +
						'</div>' +
						'<input id="tape-' + i + '-title" type="text" aria-label="Tape ' + i + ' title" name="properties[ tape-' + i + ' ][ title ]" placeholder="ex. “My Family Memories 1964”" class="p-3.5 w-full text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 title-input tape-customizer-input" maxLength="35" />' +
						'<div class="flex items-center mb-2.5">' +
						'<label class="text-xl font-medium mr-1 text-black">Estimated Media Date</label>' +
						'<div class="tooltip">' +
						'<div class="tooltip-icon" tabindex="0"><svg width="20" height="21" viewBox="0 0 20 21"><circle cx="10" cy="10.7981" r="10" fill="#4784F2"/><path d="M9.10258 15.0855V16.7505H10.7676V15.0855H9.10258ZM6.65758 9.38549H7.93258C7.93258 9.03549 7.97258 8.71049 8.05258 8.41049C8.13258 8.11049 8.25758 7.85049 8.42758 7.63049C8.60758 7.41049 8.82758 7.23549 9.08758 7.10549C9.34758 6.97549 9.65758 6.91049 10.0176 6.91049C10.5576 6.91049 10.9826 7.06549 11.2926 7.37549C11.6126 7.68549 11.7926 8.11549 11.8326 8.66549C11.8526 9.03549 11.8076 9.35049 11.6976 9.61049C11.5876 9.87049 11.4376 10.1105 11.2476 10.3305C11.0676 10.5405 10.8676 10.7455 10.6476 10.9455C10.4376 11.1355 10.2326 11.3455 10.0326 11.5755C9.84258 11.8055 9.67758 12.0705 9.53758 12.3705C9.40758 12.6605 9.33258 13.0155 9.31258 13.4355V14.1405H10.5876V13.5555C10.5876 13.2955 10.6226 13.0655 10.6926 12.8655C10.7726 12.6555 10.8726 12.4655 10.9926 12.2955C11.1226 12.1155 11.2626 11.9505 11.4126 11.8005C11.5726 11.6405 11.7326 11.4855 11.8926 11.3355C12.0526 11.1755 12.2076 11.0105 12.3576 10.8405C12.5176 10.6705 12.6576 10.4855 12.7776 10.2855C12.8976 10.0855 12.9926 9.86549 13.0626 9.62549C13.1426 9.37549 13.1826 9.09549 13.1826 8.78549C13.1826 8.30549 13.1026 7.88049 12.9426 7.51049C12.7926 7.14049 12.5776 6.83049 12.2976 6.58049C12.0176 6.32049 11.6826 6.12549 11.2926 5.99549C10.9126 5.85549 10.4876 5.78549 10.0176 5.78549C9.49758 5.78549 9.02758 5.87549 8.60758 6.05549C8.18758 6.23549 7.83258 6.49049 7.54258 6.82049C7.25258 7.14049 7.02758 7.52049 6.86758 7.96049C6.71758 8.40049 6.64758 8.87549 6.65758 9.38549Z" fill="white"/></svg></div> <div class="tooltip-content date">' + window.theme.tooltips?.estimated_date + '</div>' +
						'</div>' +
						'</div>' +
						'<div class="flex items-center">' +
						'<input id="tape-' + i + '-year" type="number" aria-label="Tape ' + i + ' year" name="properties[ tape-' + i + ' ][ year ]" placeholder="YYYY" maxLength="4" class="p-3.5 inline-block text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 w-[100px] mr-3.5 tape-customizer-input js-date-input js-year-input text-input text-center" min="1800" oninput="this.value=this.value.slice(0,this.maxLength)"/>' +
						'<input id="tape-' + i + '-month" type="number" aria-label="Tape ' + i + ' month" name="properties[ tape-' + i + ' ][ month ]" placeholder="MM" min="1" max="12" maxLength="2" class="p-3.5 inline-block text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 w-[75px] mr-3.5 tape-customizer-input js-date-input js-month-input text-input text-center" maxLength="2" oninput="this.value=this.value.slice(0,this.maxLength)"/>' +
						'<input id="tape-' + i + '-day" type="number" aria-label="Tape ' + i + ' day" name="properties[ tape-' + i + ' ][ day ]" placeholder="DD" maxLength="2" class="p-3.5 inline-block text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 w-[75px] mr-3.5 tape-customizer-input js-date-input js-day-input text-input text-center" max="31" min="1" oninput="this.value=this.value.slice(0,this.maxLength)"/>' +
						'</div>' +
						'<div class="mb-2.5">' +
						'<label for="tape-' + i + '-rewind-control" class="text-xl font-medium mr-1 text-black mb-2.5 block">Rewind Tape</label>' +
						'<p class="mb-6" >Unless you prefer to begin from a set place, our technicians will rewind your tape to the beginning before transfer.</p>' +
						'</div>' +
						'<select id="tape-' + i + '-rewind-control" name="properties[ tape-' + i + ' ][ rewind ]" class="tape-customizer-select-input">' +
						'<option value="true">Yes, please rewind tape</option>' +
						'<option value="false">No, do not rewind tape</option>' +
						'</select>'+
						'</div>'
					);

				}

			} else {

				$( '.off-canvas-tape-customizer-inputs' ).append(
					'<div class="tape-customizer-single-form ' + ( i === 0 ? '' : 'hidden' ) + '" id="tape-customizer-form-' + i + '">' +
					'<div class="flex items-center mb-2.5">' +
					'<label for="tape-' + i + '-title" class="text-xl font-medium mr-1 text-black">Album Title</label>' +
					'<div class="tooltip">' +
					'<div class="tooltip-icon" tabindex="0"><svg width="20" height="21" viewBox="0 0 20 21"><circle cx="10" cy="10.7981" r="10" fill="#4784F2"/><path d="M9.10258 15.0855V16.7505H10.7676V15.0855H9.10258ZM6.65758 9.38549H7.93258C7.93258 9.03549 7.97258 8.71049 8.05258 8.41049C8.13258 8.11049 8.25758 7.85049 8.42758 7.63049C8.60758 7.41049 8.82758 7.23549 9.08758 7.10549C9.34758 6.97549 9.65758 6.91049 10.0176 6.91049C10.5576 6.91049 10.9826 7.06549 11.2926 7.37549C11.6126 7.68549 11.7926 8.11549 11.8326 8.66549C11.8526 9.03549 11.8076 9.35049 11.6976 9.61049C11.5876 9.87049 11.4376 10.1105 11.2476 10.3305C11.0676 10.5405 10.8676 10.7455 10.6476 10.9455C10.4376 11.1355 10.2326 11.3455 10.0326 11.5755C9.84258 11.8055 9.67758 12.0705 9.53758 12.3705C9.40758 12.6605 9.33258 13.0155 9.31258 13.4355V14.1405H10.5876V13.5555C10.5876 13.2955 10.6226 13.0655 10.6926 12.8655C10.7726 12.6555 10.8726 12.4655 10.9926 12.2955C11.1226 12.1155 11.2626 11.9505 11.4126 11.8005C11.5726 11.6405 11.7326 11.4855 11.8926 11.3355C12.0526 11.1755 12.2076 11.0105 12.3576 10.8405C12.5176 10.6705 12.6576 10.4855 12.7776 10.2855C12.8976 10.0855 12.9926 9.86549 13.0626 9.62549C13.1426 9.37549 13.1826 9.09549 13.1826 8.78549C13.1826 8.30549 13.1026 7.88049 12.9426 7.51049C12.7926 7.14049 12.5776 6.83049 12.2976 6.58049C12.0176 6.32049 11.6826 6.12549 11.2926 5.99549C10.9126 5.85549 10.4876 5.78549 10.0176 5.78549C9.49758 5.78549 9.02758 5.87549 8.60758 6.05549C8.18758 6.23549 7.83258 6.49049 7.54258 6.82049C7.25258 7.14049 7.02758 7.52049 6.86758 7.96049C6.71758 8.40049 6.64758 8.87549 6.65758 9.38549Z" fill="white"/></svg></div> <div class="tooltip-content">' + window.theme.tooltips?.album_title + '</div>' +
					'</div>' +
					'</div>' +
					'<input id="tape-' + i + '-title" type="text" aria-label="Tape ' + i + ' title" name="properties[ tape-' + i + ' ][ title ]" placeholder="ex. “My Family Memories 1964”" class="p-3.5 w-full text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 title-input tape-customizer-input" maxLength="35" />' +
					'<div class="flex items-center mb-2.5">' +
					'<label class="text-xl font-medium mr-1 text-black">Estimated Media Date</label>' +
					'<div class="tooltip">' +
					'<div class="tooltip-icon" tabindex="0"><svg width="20" height="21" viewBox="0 0 20 21"><circle cx="10" cy="10.7981" r="10" fill="#4784F2"/><path d="M9.10258 15.0855V16.7505H10.7676V15.0855H9.10258ZM6.65758 9.38549H7.93258C7.93258 9.03549 7.97258 8.71049 8.05258 8.41049C8.13258 8.11049 8.25758 7.85049 8.42758 7.63049C8.60758 7.41049 8.82758 7.23549 9.08758 7.10549C9.34758 6.97549 9.65758 6.91049 10.0176 6.91049C10.5576 6.91049 10.9826 7.06549 11.2926 7.37549C11.6126 7.68549 11.7926 8.11549 11.8326 8.66549C11.8526 9.03549 11.8076 9.35049 11.6976 9.61049C11.5876 9.87049 11.4376 10.1105 11.2476 10.3305C11.0676 10.5405 10.8676 10.7455 10.6476 10.9455C10.4376 11.1355 10.2326 11.3455 10.0326 11.5755C9.84258 11.8055 9.67758 12.0705 9.53758 12.3705C9.40758 12.6605 9.33258 13.0155 9.31258 13.4355V14.1405H10.5876V13.5555C10.5876 13.2955 10.6226 13.0655 10.6926 12.8655C10.7726 12.6555 10.8726 12.4655 10.9926 12.2955C11.1226 12.1155 11.2626 11.9505 11.4126 11.8005C11.5726 11.6405 11.7326 11.4855 11.8926 11.3355C12.0526 11.1755 12.2076 11.0105 12.3576 10.8405C12.5176 10.6705 12.6576 10.4855 12.7776 10.2855C12.8976 10.0855 12.9926 9.86549 13.0626 9.62549C13.1426 9.37549 13.1826 9.09549 13.1826 8.78549C13.1826 8.30549 13.1026 7.88049 12.9426 7.51049C12.7926 7.14049 12.5776 6.83049 12.2976 6.58049C12.0176 6.32049 11.6826 6.12549 11.2926 5.99549C10.9126 5.85549 10.4876 5.78549 10.0176 5.78549C9.49758 5.78549 9.02758 5.87549 8.60758 6.05549C8.18758 6.23549 7.83258 6.49049 7.54258 6.82049C7.25258 7.14049 7.02758 7.52049 6.86758 7.96049C6.71758 8.40049 6.64758 8.87549 6.65758 9.38549Z" fill="white"/></svg></div> <div class="tooltip-content date">' + window.theme.tooltips?.estimated_date + '</div>' +
					'</div>' +
					'</div>' +
					'<div class="flex items-center">' +
					'<input id="tape-' + i + '-year" type="number" aria-label="Tape ' + i + ' year" name="properties[ tape-' + i + ' ][ year ]" placeholder="YYYY" maxLength="4" class="p-3.5 inline-block text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 w-[100px] mr-3.5 tape-customizer-input js-date-input js-year-input text-input text-center" min="1800" oninput="this.value=this.value.slice(0,this.maxLength)"/>' +
					'<input id="tape-' + i + '-month" type="number" aria-label="Tape ' + i + ' month" name="properties[ tape-' + i + ' ][ month ]" placeholder="MM" min="1" max="12" maxLength="2" class="p-3.5 inline-block text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 w-[75px] mr-3.5 tape-customizer-input js-date-input js-month-input text-input text-center" maxLength="2" oninput="this.value=this.value.slice(0,this.maxLength)"/>' +
					'<input id="tape-' + i + '-day" type="number" aria-label="Tape ' + i + ' day" name="properties[ tape-' + i + ' ][ day ]" placeholder="DD" maxLength="2" class="p-3.5 inline-block text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 w-[75px] mr-3.5 tape-customizer-input js-date-input js-day-input text-input text-center" max="31" min="1" oninput="this.value=this.value.slice(0,this.maxLength)"/>' +
					'</div>' +
					'<div class="mb-2.5">' +
					'<label for="tape-' + i + '-rewind-control" class="text-xl font-medium mr-1 text-black mb-2.5 block">Rewind Tape</label>' +
					'<p class="mb-6" >Unless you prefer to begin from a set place, our technicians will rewind your tape to the beginning before transfer.</p>' +
					'</div>' +
					'<select id="tape-' + i + '-rewind-control" name="properties[ tape-' + i + ' ][ rewind ]" class="tape-customizer-select-input">' +
					'<option value="true">Yes, please rewind tape</option>' +
					'<option value="false">No, do not rewind tape</option>' +
					'</select>'+
					'</div>'
				);

			}

		}

		//render pagination
		if( $( 'input[name="quantity"]' ).val() > 1 ) {

			$( '.off-canvas-tape-customizer-actions' ).append(
				'<button type="button" data-page="1" class="js-next-tape button button-blue !text-sm mr-3.5 mb-5">Next Tape</button>' +
				'<button type="button" data-type="tapes" class="js-save-media-details button button-blue-outline !text-sm mr-3.5 mb-5">Save & Continue</button>'
			);

			$( '.js-next-tape' ).data( 'page', '1' );

			$( '.off-canvas-tape-customizer-actions' ).removeClass( 'final-tape' );

			if( $( '.js-previous-tape' ) ) {

				$( '.js-previous-tape' ).html( 'Next Tape' );
				$( '.js-previous-tape' ).data( 'page', '1' );
				$( '.js-previous-tape' ).addClass( 'js-next-tape' );
				$( '.js-next-tape' ).removeClass( 'js-previous-tape' );

			}

		} else {

			$( '.off-canvas-tape-customizer-actions' ).append(
				'<button type="button" data-type="tapes" class="js-save-media-details button button-blue-outline !text-sm mr-3.5 mb-5">Save & Continue</button>'
			);

		}

		//ensure all year inputs have a max value of the current year
		var currentYearString = new Date().getFullYear();
		var currentYearInt = parseInt( currentYearString );

		$( '.js-year-input' ).each( function() {

			$( this ).attr( { 'max' : currentYearInt } );

		});

	};

	$( '.js-add-to-cart-tapes' ).on( 'click', function( e ) {

		triggerTapeCustomizer();

	});

    $( document ).on( 'click', '.album-customizer-select', function() {

		$( '.album-customizer-select' ).each( function() {

			$( this ).removeClass( 'active' );

		});

		$( this ).addClass( 'active' );

		let target = $( this ).attr( 'id' ).split( '-' )[ 2 ];

		if( parseInt( target ) + 1 >= $( '.album-customizer-select' ).length ) {

			$( '.album-customizer-single-form' ).each( function() {

				if( ! $( this ).hasClass( 'hidden' ) ) {

					$( this ).addClass( 'hidden' );

				}

			});

			$( '#album-customizer-form-' + target ).removeClass( 'hidden' );

			$( '.js-next-album' ).html( 'Back to Album 1' );

			$( '.js-next-album' ).addClass( 'js-previous-album' );
			$( '.js-next-album' ).addClass( 'button-blue-outline' );
			$( '.js-next-album' ).removeClass( 'button-blue' );
			$( '.js-next-album' ).removeClass( 'js-next-album' );

			$( '.js-save-media-details' ).removeClass( 'button-blue-outline' );
			$( '.js-save-media-details' ).addClass( 'button-blue' );

		} else {

			$( '.album-customizer-single-form' ).each( function() {

				if( ! $( this ).hasClass( 'hidden' ) ) {

					$( this ).addClass( 'hidden' );

				}

			});

			$( '#album-customizer-form-' + target ).removeClass( 'hidden' );

			$( '.js-next-album' ).data( 'page', parseInt( target ) + 1 );

			$( '.js-previous-album' ).html( 'Next Album' );

			$( '.js-previous-album' ).data( 'page', parseInt( target ) + 1 );

			$( '.js-previous-album' ).addClass( 'js-next-album' );
			$( '.js-previous-album' ).addClass( 'button-blue' );
			$( '.js-previous-album' ).removeClass( 'button-blue-outline' );
			$( '.js-previous-album' ).removeClass( 'js-previous-album' );

			$( '.js-save-media-details' ).addClass( 'button-blue-outline' );
			$( '.js-save-media-details' ).removeClass( 'button-blue' );

		}

	});

    $( document ).on( 'click', '.js-next-album', function() {

    	let target = $( this ).data( 'page' );

        // console.log(target);

    	$( '.album-customizer-select' ).each( function() {

    		$( this ).removeClass( 'active' );

    	});

    	$( '.album-customizer-single-form' ).each( function() {

    		if( ! $( this ).hasClass( 'hidden' ) ) {

    			$( this ).addClass( 'hidden' );

    		}

    	});

    	$( '#album-customizer-form-' + target ).removeClass( 'hidden' );

    	$( '#album-customizer-form-' + target + ' .album-customizer-input' )[ 0 ].focus();

    	if( $( '#album-button-' + target ).prop( 'disabled', true ) ) {
        // console.log('Entre');
        // console.log($( '#album-' + target ));
    		$( '#album-button-' + target ).prop( 'disabled', false );
        // console.log($( '#album-' + target ));
    	}

    	$( '#album-button-' + target ).addClass( 'active' );

    	$( '.js-next-album' ).data( 'page', parseInt( target ) + 1 );

    	if( ( parseInt( $( '.js-next-album' ).data( 'page' ) ) > ( $( 'input[name="quantity"]' ).val() - 1 ) ) ) {

    		$( '.off-canvas-album-customizer-actions' ).addClass( 'final-album' );

    		$( '.js-next-album' ).html( 'Back to Album 1' );

    		$( '.js-next-album' ).addClass( 'js-previous-album button-blue-outline' );
    		$( '.js-next-album' ).addClass( 'button-blue-outline' );
    		$( '.js-next-album' ).removeClass( 'button-blue' );
    		$( '.js-next-album' ).removeClass( 'js-next-album' );

    		$( '.js-save-media-details' ).removeClass( 'button-blue-outline' );
    		$( '.js-save-media-details' ).addClass( 'button-blue' );

    	} else {

    		$( '.js-previous-album' ).html( 'Next Album' );

    		$( '.js-previous-album' ).addClass( 'js-next-album' );
    		$( '.js-previous-album' ).addClass( 'button-blue' );
    		$( '.js-previous-album' ).removeClass( 'button-blue-outline' );
    		$( '.js-previous-album' ).removeClass( 'js-previous-album' );

    		$( '.js-save-media-details' ).addClass( 'button-blue-outline' );
    		$( '.js-save-media-details' ).removeClass( 'button-blue' );

    	}

    });

    $( document ).on( 'click', '.js-previous-album', function() {

    	$( '.album-customizer-select' ).each( function() {

    		$( this ).removeClass( 'active' );

    	});

    	var firstSelect = $( '.album-customizer-select' )[ 0 ];

    	$( firstSelect ).addClass( 'active' );

    	$( '.album-customizer-single-form' ).each( function() {

    		if( ! $( this ).hasClass( 'hidden' ) ) {

    			$( this ).addClass( 'hidden' );

    		}

    	});

    	$( '#album-0' ).removeClass( 'hidden' );
    	$( '#album-customizer-form-0' ).removeClass( 'hidden' );
    	$( '#album-customizer-form-0 .album-customizer-input' )[ 0 ].focus();

    	$( '.off-canvas-album-customizer-actions' ).removeClass( 'final-album' );

    	$( '.js-previous-album' ).html( 'Next Album' );

    	$( '.js-previous-album' ).data( 'page', '1' );

    	$( '.js-previous-album' ).addClass( 'js-next-album' );
    	$( '.js-previous-album' ).addClass( 'button-blue' );
    	$( '.js-previous-album' ).removeClass( 'button-blue-outline' );
    	$( '.js-previous-album' ).removeClass( 'js-previous-album' );

    	$( '.js-save-media-details' ).addClass( 'button-blue-outline' );
    	$( '.js-save-media-details' ).removeClass( 'button-blue' );

    });

    var triggerAlbumCustomizer = function() {


		//clears all form elements at render to ensure only the right elements are shown
		$( '.album-selector-wrappers' ).html( '' );
		$( '.off-canvas-album-customizer-inputs' ).html( '' );
		$( '.off-canvas-album-customizer-actions' ).html( '' );

		//renders out buttons for how many albums were selected
		for( var i = 0; i < $( 'input[name="quantity"]' ).val(); i++ ) {


			if( i === 0 ) {

				$( '.album-selector-wrappers' ).append( '<button type="button" class="album-customizer-select active" aria-label="Open album ' + i + ' form" id="album-button-' + i + '" >' + ( i + 1 ) + '</button>' );

			} else {

				if( searchParams.has( 'edit' ) ) {

					// $( '.album-selector-wrappers' ).append( '<button type="button" class="album-customizer-select" aria-label="Open album ' + i + ' form" id="album-' + i + '" >' + ( i + 1 ) + '</button>' );
					$( '.album-selector-wrappers' ).append( '<button type="button" class="album-customizer-select" aria-label="Open album ' + i + ' form" id="album-button-' + i + '" >' + ( i + 1 ) + '</button>' );

				} else {

					// $( '.album-selector-wrappers' ).append( '<button disabled type="button" class="album-customizer-select" aria-label="Open album ' + i + ' form" id="album-' + i + '" >' + ( i + 1 ) + '</button>' );
					$( '.album-selector-wrappers' ).append( '<button disabled type="button" class="album-customizer-select" aria-label="Open album ' + i + ' form" id="album-button-' + i + '" >' + ( i + 1 ) + '</button>' );

				}

			}

		}

		for( var i = 0; i < $( 'input[name="quantity"]' ).val(); i++ ) {

			if( searchParams.has( 'edit' ) ) {

				if( product.properties.data.value.customizations[ i ] ) {

					let dateArray = product.properties.data.value.customizations[ i ]?.media_date?.split( '/' );

					let year;
					let month;
					let day;

					if( dateArray ) {

						year = dateArray[ 0 ] ;
						month = dateArray[ 1 ];
						day = dateArray[ 2 ];

					} else {

						year = '';
						month = '';
						day = '';

					}

					$( '.off-canvas-album-customizer-inputs' ).append(
						'<div class="album-customizer-single-form ' + ( i === 0 ? '' : 'hidden' ) + '" id="album-customizer-form-' + i + '">' +
						'<div class="flex items-center mb-2.5">' +
						'<label for="album-' + i + '-title" class="text-xl font-medium mr-1 text-black">Album Title</label>' +
						'<div class="tooltip">' +
						'<div class="tooltip-icon" tabindex="0"><svg width="20" height="21" viewBox="0 0 20 21"><circle cx="10" cy="10.7981" r="10" fill="#4784F2"/><path d="M9.10258 15.0855V16.7505H10.7676V15.0855H9.10258ZM6.65758 9.38549H7.93258C7.93258 9.03549 7.97258 8.71049 8.05258 8.41049C8.13258 8.11049 8.25758 7.85049 8.42758 7.63049C8.60758 7.41049 8.82758 7.23549 9.08758 7.10549C9.34758 6.97549 9.65758 6.91049 10.0176 6.91049C10.5576 6.91049 10.9826 7.06549 11.2926 7.37549C11.6126 7.68549 11.7926 8.11549 11.8326 8.66549C11.8526 9.03549 11.8076 9.35049 11.6976 9.61049C11.5876 9.87049 11.4376 10.1105 11.2476 10.3305C11.0676 10.5405 10.8676 10.7455 10.6476 10.9455C10.4376 11.1355 10.2326 11.3455 10.0326 11.5755C9.84258 11.8055 9.67758 12.0705 9.53758 12.3705C9.40758 12.6605 9.33258 13.0155 9.31258 13.4355V14.1405H10.5876V13.5555C10.5876 13.2955 10.6226 13.0655 10.6926 12.8655C10.7726 12.6555 10.8726 12.4655 10.9926 12.2955C11.1226 12.1155 11.2626 11.9505 11.4126 11.8005C11.5726 11.6405 11.7326 11.4855 11.8926 11.3355C12.0526 11.1755 12.2076 11.0105 12.3576 10.8405C12.5176 10.6705 12.6576 10.4855 12.7776 10.2855C12.8976 10.0855 12.9926 9.86549 13.0626 9.62549C13.1426 9.37549 13.1826 9.09549 13.1826 8.78549C13.1826 8.30549 13.1026 7.88049 12.9426 7.51049C12.7926 7.14049 12.5776 6.83049 12.2976 6.58049C12.0176 6.32049 11.6826 6.12549 11.2926 5.99549C10.9126 5.85549 10.4876 5.78549 10.0176 5.78549C9.49758 5.78549 9.02758 5.87549 8.60758 6.05549C8.18758 6.23549 7.83258 6.49049 7.54258 6.82049C7.25258 7.14049 7.02758 7.52049 6.86758 7.96049C6.71758 8.40049 6.64758 8.87549 6.65758 9.38549Z" fill="white"/></svg></div> <div class="tooltip-content">' + window.theme.tooltips?.album_title + '</div>' +
						'</div>' +
						'</div>' +
						'<input id="album-' + i + '-title" type="text" aria-label="Album ' + i + ' title" name="properties[ album-' + i + ' ][ title ]" placeholder="ex. “My Family Memories 1964”" class="p-3.5 w-full text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 album-customizer-input title-input" maxLength="35" value="' + product.properties.data.value.customizations[ i ].title + '" />' +
						'<div class="flex items-center mb-2.5">' +
						'<label class="text-xl font-medium mr-1 text-black">Estimated Media Date</label>' +
						'<div class="tooltip">' +
						'<div class="tooltip-icon" tabindex="0"><svg width="20" height="21" viewBox="0 0 20 21"><circle cx="10" cy="10.7981" r="10" fill="#4784F2"/><path d="M9.10258 15.0855V16.7505H10.7676V15.0855H9.10258ZM6.65758 9.38549H7.93258C7.93258 9.03549 7.97258 8.71049 8.05258 8.41049C8.13258 8.11049 8.25758 7.85049 8.42758 7.63049C8.60758 7.41049 8.82758 7.23549 9.08758 7.10549C9.34758 6.97549 9.65758 6.91049 10.0176 6.91049C10.5576 6.91049 10.9826 7.06549 11.2926 7.37549C11.6126 7.68549 11.7926 8.11549 11.8326 8.66549C11.8526 9.03549 11.8076 9.35049 11.6976 9.61049C11.5876 9.87049 11.4376 10.1105 11.2476 10.3305C11.0676 10.5405 10.8676 10.7455 10.6476 10.9455C10.4376 11.1355 10.2326 11.3455 10.0326 11.5755C9.84258 11.8055 9.67758 12.0705 9.53758 12.3705C9.40758 12.6605 9.33258 13.0155 9.31258 13.4355V14.1405H10.5876V13.5555C10.5876 13.2955 10.6226 13.0655 10.6926 12.8655C10.7726 12.6555 10.8726 12.4655 10.9926 12.2955C11.1226 12.1155 11.2626 11.9505 11.4126 11.8005C11.5726 11.6405 11.7326 11.4855 11.8926 11.3355C12.0526 11.1755 12.2076 11.0105 12.3576 10.8405C12.5176 10.6705 12.6576 10.4855 12.7776 10.2855C12.8976 10.0855 12.9926 9.86549 13.0626 9.62549C13.1426 9.37549 13.1826 9.09549 13.1826 8.78549C13.1826 8.30549 13.1026 7.88049 12.9426 7.51049C12.7926 7.14049 12.5776 6.83049 12.2976 6.58049C12.0176 6.32049 11.6826 6.12549 11.2926 5.99549C10.9126 5.85549 10.4876 5.78549 10.0176 5.78549C9.49758 5.78549 9.02758 5.87549 8.60758 6.05549C8.18758 6.23549 7.83258 6.49049 7.54258 6.82049C7.25258 7.14049 7.02758 7.52049 6.86758 7.96049C6.71758 8.40049 6.64758 8.87549 6.65758 9.38549Z" fill="white"/></svg></div> <div class="tooltip-content date">' + window.theme.tooltips?.estimated_date + '</div>' +
						'</div>' +
						'</div>' +
						'<div class="flex items-center">' +
						'<label for="album-' + i + '-year" style="opacity:0;font-size:0;margin:0">Album Year</label>' +
						'<input id="album-' + i + '-year" type="number" aria-label="Album ' + i + ' year" name="properties[ album-' + i + ' ][ year ]" placeholder="YYYY" maxLength="4" class="p-3.5 inline-block text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 w-[100px] mr-3.5 album-customizer-input js-date-input js-year-input text-input text-center" min="1800" oninput="this.value=this.value.slice(0,this.maxLength)" value="' + year + '"/>' +
						'<label for="album-' + i + '-month" style="opacity:0;font-size:0;margin:0">Album Month</label>' +
						'<input id="album-' + i + '-month" type="number" aria-label="Album ' + i + ' month" name="properties[ album-' + i + ' ][ month ]" placeholder="MM" min="1" max="12" maxLength="2" class="p-3.5 inline-block text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 w-[75px] mr-3.5 album-customizer-input js-date-input js-month-input text-input text-center" maxLength="2" oninput="this.value=this.value.slice(0,this.maxLength)" value="' + month + '"/>' +
						'<label for="album-' + i + '-day" style="opacity:0;font-size:0;margin:0">Album Day</label>' +
						'<input id="album-' + i + '-day" type="number" aria-label="Album ' + i + ' day" name="properties[ album-' + i + ' ][ day ]" placeholder="DD" maxLength="2" class="p-3.5 inline-block text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 w-[75px] mr-3.5 album-customizer-input js-date-input js-day-input text-input text-center" max="31" min="1" oninput="this.value=this.value.slice(0,this.maxLength)" value="' + day + '"/>' +
						'</div>' +
						'</div>'
					);

				} else {

					$( '.off-canvas-album-customizer-inputs' ).append(
						'<div class="album-customizer-single-form ' + ( i === 0 ? '' : 'hidden' ) + '" id="album-customizer-form-' + i + '">' +
						'<div class="flex items-center mb-2.5">' +
						'<label for="album-' + i + '-title" class="text-xl font-medium mr-1 text-black">Album Title</label>' +
						'<div class="tooltip">' +
						'<div class="tooltip-icon" tabindex="0"><svg width="20" height="21" viewBox="0 0 20 21"><circle cx="10" cy="10.7981" r="10" fill="#4784F2"/><path d="M9.10258 15.0855V16.7505H10.7676V15.0855H9.10258ZM6.65758 9.38549H7.93258C7.93258 9.03549 7.97258 8.71049 8.05258 8.41049C8.13258 8.11049 8.25758 7.85049 8.42758 7.63049C8.60758 7.41049 8.82758 7.23549 9.08758 7.10549C9.34758 6.97549 9.65758 6.91049 10.0176 6.91049C10.5576 6.91049 10.9826 7.06549 11.2926 7.37549C11.6126 7.68549 11.7926 8.11549 11.8326 8.66549C11.8526 9.03549 11.8076 9.35049 11.6976 9.61049C11.5876 9.87049 11.4376 10.1105 11.2476 10.3305C11.0676 10.5405 10.8676 10.7455 10.6476 10.9455C10.4376 11.1355 10.2326 11.3455 10.0326 11.5755C9.84258 11.8055 9.67758 12.0705 9.53758 12.3705C9.40758 12.6605 9.33258 13.0155 9.31258 13.4355V14.1405H10.5876V13.5555C10.5876 13.2955 10.6226 13.0655 10.6926 12.8655C10.7726 12.6555 10.8726 12.4655 10.9926 12.2955C11.1226 12.1155 11.2626 11.9505 11.4126 11.8005C11.5726 11.6405 11.7326 11.4855 11.8926 11.3355C12.0526 11.1755 12.2076 11.0105 12.3576 10.8405C12.5176 10.6705 12.6576 10.4855 12.7776 10.2855C12.8976 10.0855 12.9926 9.86549 13.0626 9.62549C13.1426 9.37549 13.1826 9.09549 13.1826 8.78549C13.1826 8.30549 13.1026 7.88049 12.9426 7.51049C12.7926 7.14049 12.5776 6.83049 12.2976 6.58049C12.0176 6.32049 11.6826 6.12549 11.2926 5.99549C10.9126 5.85549 10.4876 5.78549 10.0176 5.78549C9.49758 5.78549 9.02758 5.87549 8.60758 6.05549C8.18758 6.23549 7.83258 6.49049 7.54258 6.82049C7.25258 7.14049 7.02758 7.52049 6.86758 7.96049C6.71758 8.40049 6.64758 8.87549 6.65758 9.38549Z" fill="white"/></svg></div> <div class="tooltip-content">' + window.theme.tooltips?.album_title + '</div>' +
						'</div>' +
						'</div>' +
						'<input id="album-' + i + '-title" type="text" aria-label="Album ' + i + ' title" name="properties[ album-' + i + ' ][ title ]" placeholder="ex. “My Family Memories 1964”" class="p-3.5 w-full text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 title-input album-customizer-input" maxLength="35" />' +
						'<div class="flex items-center mb-2.5">' +
						'<label class="text-xl font-medium mr-1 text-black">Estimated Media Date</label>' +
						'<div class="tooltip">' +
						'<div class="tooltip-icon" tabindex="0"><svg width="20" height="21" viewBox="0 0 20 21"><circle cx="10" cy="10.7981" r="10" fill="#4784F2"/><path d="M9.10258 15.0855V16.7505H10.7676V15.0855H9.10258ZM6.65758 9.38549H7.93258C7.93258 9.03549 7.97258 8.71049 8.05258 8.41049C8.13258 8.11049 8.25758 7.85049 8.42758 7.63049C8.60758 7.41049 8.82758 7.23549 9.08758 7.10549C9.34758 6.97549 9.65758 6.91049 10.0176 6.91049C10.5576 6.91049 10.9826 7.06549 11.2926 7.37549C11.6126 7.68549 11.7926 8.11549 11.8326 8.66549C11.8526 9.03549 11.8076 9.35049 11.6976 9.61049C11.5876 9.87049 11.4376 10.1105 11.2476 10.3305C11.0676 10.5405 10.8676 10.7455 10.6476 10.9455C10.4376 11.1355 10.2326 11.3455 10.0326 11.5755C9.84258 11.8055 9.67758 12.0705 9.53758 12.3705C9.40758 12.6605 9.33258 13.0155 9.31258 13.4355V14.1405H10.5876V13.5555C10.5876 13.2955 10.6226 13.0655 10.6926 12.8655C10.7726 12.6555 10.8726 12.4655 10.9926 12.2955C11.1226 12.1155 11.2626 11.9505 11.4126 11.8005C11.5726 11.6405 11.7326 11.4855 11.8926 11.3355C12.0526 11.1755 12.2076 11.0105 12.3576 10.8405C12.5176 10.6705 12.6576 10.4855 12.7776 10.2855C12.8976 10.0855 12.9926 9.86549 13.0626 9.62549C13.1426 9.37549 13.1826 9.09549 13.1826 8.78549C13.1826 8.30549 13.1026 7.88049 12.9426 7.51049C12.7926 7.14049 12.5776 6.83049 12.2976 6.58049C12.0176 6.32049 11.6826 6.12549 11.2926 5.99549C10.9126 5.85549 10.4876 5.78549 10.0176 5.78549C9.49758 5.78549 9.02758 5.87549 8.60758 6.05549C8.18758 6.23549 7.83258 6.49049 7.54258 6.82049C7.25258 7.14049 7.02758 7.52049 6.86758 7.96049C6.71758 8.40049 6.64758 8.87549 6.65758 9.38549Z" fill="white"/></svg></div> <div class="tooltip-content date">' + window.theme.tooltips?.estimated_date + '</div>' +
						'</div>' +
						'</div>' +
						'<div class="flex items-center">' +
						'<input id="album-' + i + '-year" type="number" aria-label="Album ' + i + ' year" name="properties[ album-' + i + ' ][ year ]" placeholder="YYYY" maxLength="4" class="p-3.5 inline-block text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 w-[100px] mr-3.5 album-customizer-input js-date-input js-year-input text-input text-center" min="1800" oninput="this.value=this.value.slice(0,this.maxLength)"/>' +
						'<input id="album-' + i + '-month" type="number" aria-label="Album ' + i + ' month" name="properties[ album-' + i + ' ][ month ]" placeholder="MM" min="1" max="12" maxLength="2" class="p-3.5 inline-block text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 w-[75px] mr-3.5 album-customizer-input js-date-input js-month-input text-input text-center" maxLength="2" oninput="this.value=this.value.slice(0,this.maxLength)"/>' +
						'<input id="album-' + i + '-day" type="number" aria-label="Album ' + i + ' day" name="properties[ album-' + i + ' ][ day ]" placeholder="DD" maxLength="2" class="p-3.5 inline-block text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 w-[75px] mr-3.5 album-customizer-input js-date-input js-day-input text-input text-center" max="31" min="1" oninput="this.value=this.value.slice(0,this.maxLength)"/>' +
						'</div>' +
						'</div>'
					);

				}

			} else {

				$( '.off-canvas-album-customizer-inputs' ).append(
					'<div class="album-customizer-single-form ' + ( i === 0 ? '' : 'hidden' ) + '" id="album-customizer-form-' + i + '">' +
					'<div class="flex items-center mb-2.5">' +
					'<label for="album-' + i + '-title" class="text-xl font-medium mr-1 text-black">Album Title</label>' +
					'<div class="tooltip">' +
					'<div class="tooltip-icon" tabindex="0"><svg width="20" height="21" viewBox="0 0 20 21"><circle cx="10" cy="10.7981" r="10" fill="#4784F2"/><path d="M9.10258 15.0855V16.7505H10.7676V15.0855H9.10258ZM6.65758 9.38549H7.93258C7.93258 9.03549 7.97258 8.71049 8.05258 8.41049C8.13258 8.11049 8.25758 7.85049 8.42758 7.63049C8.60758 7.41049 8.82758 7.23549 9.08758 7.10549C9.34758 6.97549 9.65758 6.91049 10.0176 6.91049C10.5576 6.91049 10.9826 7.06549 11.2926 7.37549C11.6126 7.68549 11.7926 8.11549 11.8326 8.66549C11.8526 9.03549 11.8076 9.35049 11.6976 9.61049C11.5876 9.87049 11.4376 10.1105 11.2476 10.3305C11.0676 10.5405 10.8676 10.7455 10.6476 10.9455C10.4376 11.1355 10.2326 11.3455 10.0326 11.5755C9.84258 11.8055 9.67758 12.0705 9.53758 12.3705C9.40758 12.6605 9.33258 13.0155 9.31258 13.4355V14.1405H10.5876V13.5555C10.5876 13.2955 10.6226 13.0655 10.6926 12.8655C10.7726 12.6555 10.8726 12.4655 10.9926 12.2955C11.1226 12.1155 11.2626 11.9505 11.4126 11.8005C11.5726 11.6405 11.7326 11.4855 11.8926 11.3355C12.0526 11.1755 12.2076 11.0105 12.3576 10.8405C12.5176 10.6705 12.6576 10.4855 12.7776 10.2855C12.8976 10.0855 12.9926 9.86549 13.0626 9.62549C13.1426 9.37549 13.1826 9.09549 13.1826 8.78549C13.1826 8.30549 13.1026 7.88049 12.9426 7.51049C12.7926 7.14049 12.5776 6.83049 12.2976 6.58049C12.0176 6.32049 11.6826 6.12549 11.2926 5.99549C10.9126 5.85549 10.4876 5.78549 10.0176 5.78549C9.49758 5.78549 9.02758 5.87549 8.60758 6.05549C8.18758 6.23549 7.83258 6.49049 7.54258 6.82049C7.25258 7.14049 7.02758 7.52049 6.86758 7.96049C6.71758 8.40049 6.64758 8.87549 6.65758 9.38549Z" fill="white"/></svg></div> <div class="tooltip-content">' + window.theme.tooltips?.album_title + '</div>' +
					'</div>' +
					'</div>' +
					'<input id="album-' + i + '-title" type="text" aria-label="Album ' + i + ' title" name="properties[ album-' + i + ' ][ title ]" placeholder="ex. “My Family Memories 1964”" class="p-3.5 w-full text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 title-input album-customizer-input" maxLength="35" />' +
					'<div class="flex items-center mb-2.5">' +
					'<label class="text-xl font-medium mr-1 text-black">Estimated Media Date</label>' +
					'<div class="tooltip">' +
					'<div class="tooltip-icon" tabindex="0"><svg width="20" height="21" viewBox="0 0 20 21"><circle cx="10" cy="10.7981" r="10" fill="#4784F2"/><path d="M9.10258 15.0855V16.7505H10.7676V15.0855H9.10258ZM6.65758 9.38549H7.93258C7.93258 9.03549 7.97258 8.71049 8.05258 8.41049C8.13258 8.11049 8.25758 7.85049 8.42758 7.63049C8.60758 7.41049 8.82758 7.23549 9.08758 7.10549C9.34758 6.97549 9.65758 6.91049 10.0176 6.91049C10.5576 6.91049 10.9826 7.06549 11.2926 7.37549C11.6126 7.68549 11.7926 8.11549 11.8326 8.66549C11.8526 9.03549 11.8076 9.35049 11.6976 9.61049C11.5876 9.87049 11.4376 10.1105 11.2476 10.3305C11.0676 10.5405 10.8676 10.7455 10.6476 10.9455C10.4376 11.1355 10.2326 11.3455 10.0326 11.5755C9.84258 11.8055 9.67758 12.0705 9.53758 12.3705C9.40758 12.6605 9.33258 13.0155 9.31258 13.4355V14.1405H10.5876V13.5555C10.5876 13.2955 10.6226 13.0655 10.6926 12.8655C10.7726 12.6555 10.8726 12.4655 10.9926 12.2955C11.1226 12.1155 11.2626 11.9505 11.4126 11.8005C11.5726 11.6405 11.7326 11.4855 11.8926 11.3355C12.0526 11.1755 12.2076 11.0105 12.3576 10.8405C12.5176 10.6705 12.6576 10.4855 12.7776 10.2855C12.8976 10.0855 12.9926 9.86549 13.0626 9.62549C13.1426 9.37549 13.1826 9.09549 13.1826 8.78549C13.1826 8.30549 13.1026 7.88049 12.9426 7.51049C12.7926 7.14049 12.5776 6.83049 12.2976 6.58049C12.0176 6.32049 11.6826 6.12549 11.2926 5.99549C10.9126 5.85549 10.4876 5.78549 10.0176 5.78549C9.49758 5.78549 9.02758 5.87549 8.60758 6.05549C8.18758 6.23549 7.83258 6.49049 7.54258 6.82049C7.25258 7.14049 7.02758 7.52049 6.86758 7.96049C6.71758 8.40049 6.64758 8.87549 6.65758 9.38549Z" fill="white"/></svg></div> <div class="tooltip-content date">' + window.theme.tooltips?.estimated_date + '</div>' +
					'</div>' +
					'</div>' +
					'<div class="flex items-center">' +
					'<input id="album-' + i + '-year" type="number" aria-label="Album ' + i + ' year" name="properties[ album-' + i + ' ][ year ]" placeholder="YYYY" maxLength="4" class="p-3.5 inline-block text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 w-[100px] mr-3.5 album-customizer-input js-date-input js-year-input text-input text-center" min="1800" oninput="this.value=this.value.slice(0,this.maxLength)"/>' +
					'<input id="album-' + i + '-month" type="number" aria-label="Album ' + i + ' month" name="properties[ album-' + i + ' ][ month ]" placeholder="MM" min="1" max="12" maxLength="2" class="p-3.5 inline-block text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 w-[75px] mr-3.5 album-customizer-input js-date-input js-month-input text-input text-center" maxLength="2" oninput="this.value=this.value.slice(0,this.maxLength)"/>' +
					'<input id="album-' + i + '-day" type="number" aria-label="Album ' + i + ' day" name="properties[ album-' + i + ' ][ day ]" placeholder="DD" maxLength="2" class="p-3.5 inline-block text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 w-[75px] mr-3.5 album-customizer-input js-date-input js-day-input text-input text-center" max="31" min="1" oninput="this.value=this.value.slice(0,this.maxLength)"/>' +
					'</div>' +
					'</div>'
				);

			}

		}

		//render pagination
		if( $( 'input[name="quantity"]' ).val() > 1 ) {

			$( '.off-canvas-album-customizer-actions' ).append(
				'<button type="button" data-page="1" class="js-next-album button button-blue !text-sm mr-3.5 mb-5">Next Album</button>' +
				'<button type="button" data-type="album_scan" class="js-save-media-details button button-blue-outline !text-sm mr-3.5 mb-5">Save & Continue</button>'
			);

			$( '.js-next-album' ).data( 'page', '1' );

			$( '.off-canvas-album-customizer-actions' ).removeClass( 'final-album' );

			if( $( '.js-previous-album' ) ) {

				$( '.js-previous-album' ).html( 'Next Album' );
				$( '.js-previous-album' ).data( 'page', '1' );
				$( '.js-previous-album' ).addClass( 'js-next-album' );
				$( '.js-next-album' ).removeClass( 'js-previous-album' );

			}

		} else {

			$( '.off-canvas-album-customizer-actions' ).append(
				'<button type="button" data-type="album_scan" class="js-save-media-details button button-blue-outline !text-sm mr-3.5 mb-5">Save & Continue</button>'
			);

		}

		//ensure all year inputs have a max value of the current year
		var currentYearString = new Date().getFullYear();
		var currentYearInt = parseInt( currentYearString );

		$( '.js-year-input' ).each( function() {

			$( this ).attr( { 'max' : currentYearInt } );

		});

	};


    $( '.js-add-to-cart-album' ).on( 'click', function( e ) {

    // console.log('abc123');

		triggerAlbumCustomizer();

	});

	$( document ).on( 'click', '.tape-customizer-select', function() {

		$( '.tape-customizer-select' ).each( function() {

			$( this ).removeClass( 'active' );

		});

		$( this ).addClass( 'active' );

		let target = $( this ).attr( 'id' ).split( '-' )[ 1 ];

		if( parseInt( target ) + 1 >= $( '.tape-customizer-select' ).length ) {

			$( '.tape-customizer-single-form' ).each( function() {

				if( ! $( this ).hasClass( 'hidden' ) ) {

					$( this ).addClass( 'hidden' );

				}

			});

			$( '#tape-customizer-form-' + target ).removeClass( 'hidden' );

			$( '.js-next-tape' ).html( 'Back to Tape 1' );

			$( '.js-next-tape' ).addClass( 'js-previous-tape' );
			$( '.js-next-tape' ).addClass( 'button-blue-outline' );
			$( '.js-next-tape' ).removeClass( 'button-blue' );
			$( '.js-next-tape' ).removeClass( 'js-next-tape' );

			$( '.js-save-media-details' ).removeClass( 'button-blue-outline' );
			$( '.js-save-media-details' ).addClass( 'button-blue' );

		} else {

			$( '.tape-customizer-single-form' ).each( function() {

				if( ! $( this ).hasClass( 'hidden' ) ) {

					$( this ).addClass( 'hidden' );

				}

			});

			$( '#tape-customizer-form-' + target ).removeClass( 'hidden' );

			$( '.js-next-tape' ).data( 'page', parseInt( target ) + 1 );

			$( '.js-previous-tape' ).html( 'Next Tape' );

			$( '.js-previous-tape' ).data( 'page', parseInt( target ) + 1 );

			$( '.js-previous-tape' ).addClass( 'js-next-tape' );
			$( '.js-previous-tape' ).addClass( 'button-blue' );
			$( '.js-previous-tape' ).removeClass( 'button-blue-outline' );
			$( '.js-previous-tape' ).removeClass( 'js-previous-tape' );

			$( '.js-save-media-details' ).addClass( 'button-blue-outline' );
			$( '.js-save-media-details' ).removeClass( 'button-blue' );

		}

	});

	$( document ).on( 'click', '.js-next-tape', function() {

		let target = $( this ).data( 'page' );

		$( '.tape-customizer-select' ).each( function() {

			$( this ).removeClass( 'active' );

		});

		$( '.tape-customizer-single-form' ).each( function() {

			if( ! $( this ).hasClass( 'hidden' ) ) {

				$( this ).addClass( 'hidden' );

			}

		});

		$( '#tape-customizer-form-' + target ).removeClass( 'hidden' );

		$( '#tape-customizer-form-' + target + ' .tape-customizer-input' )[ 0 ].focus();

		if( $( '#tape-' + target ).prop( 'disabled', true ) ) {

			$( '#tape-' + target ).prop( 'disabled', false );
		}

		$( '#tape-' + target ).addClass( 'active' );

		$( '.js-next-tape' ).data( 'page', parseInt( target ) + 1 );

		if( ( parseInt( $( '.js-next-tape' ).data( 'page' ) ) > ( $( 'input[name="quantity"]' ).val() - 1 ) ) ) {

			$( '.off-canvas-tape-customizer-actions' ).addClass( 'final-tape' );

			$( '.js-next-tape' ).html( 'Back to Tape 1' );

			$( '.js-next-tape' ).addClass( 'js-previous-tape button-blue-outline' );
			$( '.js-next-tape' ).addClass( 'button-blue-outline' );
			$( '.js-next-tape' ).removeClass( 'button-blue' );
			$( '.js-next-tape' ).removeClass( 'js-next-tape' );

			$( '.js-save-media-details' ).removeClass( 'button-blue-outline' );
			$( '.js-save-media-details' ).addClass( 'button-blue' );

		} else {

			$( '.js-previous-tape' ).html( 'Next Tape' );

			$( '.js-previous-tape' ).addClass( 'js-next-tape' );
			$( '.js-previous-tape' ).addClass( 'button-blue' );
			$( '.js-previous-tape' ).removeClass( 'button-blue-outline' );
			$( '.js-previous-tape' ).removeClass( 'js-previous-tape' );

			$( '.js-save-media-details' ).addClass( 'button-blue-outline' );
			$( '.js-save-media-details' ).removeClass( 'button-blue' );

		}

	});

	$( document ).on( 'click', '.js-previous-tape', function() {

		$( '.tape-customizer-select' ).each( function() {

			$( this ).removeClass( 'active' );

		});

		var firstSelect = $( '.tape-customizer-select' )[ 0 ];

		$( firstSelect ).addClass( 'active' );

		$( '.tape-customizer-single-form' ).each( function() {

			if( ! $( this ).hasClass( 'hidden' ) ) {

				$( this ).addClass( 'hidden' );

			}

		});

		$( '#tape-0' ).removeClass( 'hidden' );
		$( '#tape-customizer-form-0' ).removeClass( 'hidden' );
		$( '#tape-customizer-form-0 .tape-customizer-input' )[ 0 ].focus();

		$( '.off-canvas-tape-customizer-actions' ).removeClass( 'final-tape' );

		$( '.js-previous-tape' ).html( 'Next Tape' );

		$( '.js-previous-tape' ).data( 'page', '1' );

		$( '.js-previous-tape' ).addClass( 'js-next-tape' );
		$( '.js-previous-tape' ).addClass( 'button-blue' );
		$( '.js-previous-tape' ).removeClass( 'button-blue-outline' );
		$( '.js-previous-tape' ).removeClass( 'js-previous-tape' );

		$( '.js-save-media-details' ).addClass( 'button-blue-outline' );
		$( '.js-save-media-details' ).removeClass( 'button-blue' );

	});

	var triggerDigitalCustomizer = function() {

		//clears all form elements at render to ensure only the right elements are shown
		$( '.digital-selector-wrappers' ).html( '' );
		$( '.off-canvas-digital-customizer-inputs' ).html( '' );
		$( '.off-canvas-digital-customizer-actions' ).html( '' );

		//renders out buttons for how many digitals were selected
		for( var i = 0; i < $( 'input[name="quantity"]' ).val(); i++ ) {

			if( i === 0 ) {

				$( '.digital-selector-wrappers' ).append( '<button type="button" class="digital-customizer-select active" aria-label="Open digital ' + i + ' form" id="digital-' + i + '" >' + ( i + 1 ) + '</button>' );

			} else {

				if( searchParams.has( 'edit' ) ) {

					$( '.digital-selector-wrappers' ).append( '<button type="button" class="digital-customizer-select" aria-label="Open digital ' + i + ' form" id="digital-' + i + '" >' + ( i + 1 ) + '</button>' );

				} else {

					$( '.digital-selector-wrappers' ).append( '<button disabled type="button" class="digital-customizer-select" aria-label="Open digital ' + i + ' form" id="digital-' + i + '" >' + ( i + 1 ) + '</button>' );

				}

			}

		}

		for( var i = 0; i < $( 'input[name="quantity"]' ).val(); i++ ) {

			if( searchParams.has( 'edit' ) ) {

				if( product.properties.data.value.customizations[ i ] ) {

					let dateArray = product.properties.data.value.customizations[ i ]?.media_date?.split( '/' );

					let year;
					let month;
					let day;

					if( dateArray ) {

						year = dateArray[ 0 ] ;
						month = dateArray[ 1 ];
						day = dateArray[ 2 ];

					} else {

						year = '';
						month = '';
						day = '';

					}

					$( '.off-canvas-digital-customizer-inputs' ).append(
						'<div class="digital-customizer-single-form ' + ( i === 0 ? '' : 'hidden' ) + '" id="digital-customizer-form-' + i + '">' +
						'<div class="flex items-center mb-2.5">' +
						'<label for="digital-' + i + '-title" class="text-xl font-medium mr-1 text-black">Album Title</label>' +
						'<div class="tooltip">' +
						'<div class="tooltip-icon" tabindex="0"><svg width="20" height="21" viewBox="0 0 20 21"><circle cx="10" cy="10.7981" r="10" fill="#4784F2"/><path d="M9.10258 15.0855V16.7505H10.7676V15.0855H9.10258ZM6.65758 9.38549H7.93258C7.93258 9.03549 7.97258 8.71049 8.05258 8.41049C8.13258 8.11049 8.25758 7.85049 8.42758 7.63049C8.60758 7.41049 8.82758 7.23549 9.08758 7.10549C9.34758 6.97549 9.65758 6.91049 10.0176 6.91049C10.5576 6.91049 10.9826 7.06549 11.2926 7.37549C11.6126 7.68549 11.7926 8.11549 11.8326 8.66549C11.8526 9.03549 11.8076 9.35049 11.6976 9.61049C11.5876 9.87049 11.4376 10.1105 11.2476 10.3305C11.0676 10.5405 10.8676 10.7455 10.6476 10.9455C10.4376 11.1355 10.2326 11.3455 10.0326 11.5755C9.84258 11.8055 9.67758 12.0705 9.53758 12.3705C9.40758 12.6605 9.33258 13.0155 9.31258 13.4355V14.1405H10.5876V13.5555C10.5876 13.2955 10.6226 13.0655 10.6926 12.8655C10.7726 12.6555 10.8726 12.4655 10.9926 12.2955C11.1226 12.1155 11.2626 11.9505 11.4126 11.8005C11.5726 11.6405 11.7326 11.4855 11.8926 11.3355C12.0526 11.1755 12.2076 11.0105 12.3576 10.8405C12.5176 10.6705 12.6576 10.4855 12.7776 10.2855C12.8976 10.0855 12.9926 9.86549 13.0626 9.62549C13.1426 9.37549 13.1826 9.09549 13.1826 8.78549C13.1826 8.30549 13.1026 7.88049 12.9426 7.51049C12.7926 7.14049 12.5776 6.83049 12.2976 6.58049C12.0176 6.32049 11.6826 6.12549 11.2926 5.99549C10.9126 5.85549 10.4876 5.78549 10.0176 5.78549C9.49758 5.78549 9.02758 5.87549 8.60758 6.05549C8.18758 6.23549 7.83258 6.49049 7.54258 6.82049C7.25258 7.14049 7.02758 7.52049 6.86758 7.96049C6.71758 8.40049 6.64758 8.87549 6.65758 9.38549Z" fill="white"/></svg></div> <div class="tooltip-content">' + window.theme.tooltips.album_title + '</div>' +
						'</div>' +
						'</div>' +
						'<input id="digital-' + i + '-title" type="text" aria-label="digital ' + i + ' title" name="properties[ digital-' + i + ' ][ title ]" placeholder="ex. “My Family Memories 1964”" class="p-3.5 w-full text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 title-input digital-customizer-input" maxLength="35" value="' + product.properties.data.value.customizations[ i ].title + '" />' +
						'<div class="flex items-center mb-2.5">' +
						'<label class="text-xl font-medium mr-1 text-black">Estimated Media Date</label>' +
						'<div class="tooltip">' +
						'<div class="tooltip-icon" tabindex="0"><svg width="20" height="21" viewBox="0 0 20 21"><circle cx="10" cy="10.7981" r="10" fill="#4784F2"/><path d="M9.10258 15.0855V16.7505H10.7676V15.0855H9.10258ZM6.65758 9.38549H7.93258C7.93258 9.03549 7.97258 8.71049 8.05258 8.41049C8.13258 8.11049 8.25758 7.85049 8.42758 7.63049C8.60758 7.41049 8.82758 7.23549 9.08758 7.10549C9.34758 6.97549 9.65758 6.91049 10.0176 6.91049C10.5576 6.91049 10.9826 7.06549 11.2926 7.37549C11.6126 7.68549 11.7926 8.11549 11.8326 8.66549C11.8526 9.03549 11.8076 9.35049 11.6976 9.61049C11.5876 9.87049 11.4376 10.1105 11.2476 10.3305C11.0676 10.5405 10.8676 10.7455 10.6476 10.9455C10.4376 11.1355 10.2326 11.3455 10.0326 11.5755C9.84258 11.8055 9.67758 12.0705 9.53758 12.3705C9.40758 12.6605 9.33258 13.0155 9.31258 13.4355V14.1405H10.5876V13.5555C10.5876 13.2955 10.6226 13.0655 10.6926 12.8655C10.7726 12.6555 10.8726 12.4655 10.9926 12.2955C11.1226 12.1155 11.2626 11.9505 11.4126 11.8005C11.5726 11.6405 11.7326 11.4855 11.8926 11.3355C12.0526 11.1755 12.2076 11.0105 12.3576 10.8405C12.5176 10.6705 12.6576 10.4855 12.7776 10.2855C12.8976 10.0855 12.9926 9.86549 13.0626 9.62549C13.1426 9.37549 13.1826 9.09549 13.1826 8.78549C13.1826 8.30549 13.1026 7.88049 12.9426 7.51049C12.7926 7.14049 12.5776 6.83049 12.2976 6.58049C12.0176 6.32049 11.6826 6.12549 11.2926 5.99549C10.9126 5.85549 10.4876 5.78549 10.0176 5.78549C9.49758 5.78549 9.02758 5.87549 8.60758 6.05549C8.18758 6.23549 7.83258 6.49049 7.54258 6.82049C7.25258 7.14049 7.02758 7.52049 6.86758 7.96049C6.71758 8.40049 6.64758 8.87549 6.65758 9.38549Z" fill="white"/></svg></div> <div class="tooltip-content date">' + window.theme.tooltips.estimated_date + '</div>' +
						'</div>' +
						'</div>' +
						'<div class="flex items-center">' +
						'<label for="digital-' + i + '-year" style="opacity:0;font-size:0;margin:0">digital Year</label>' +
						'<input id="digital-' + i + '-year" type="number" aria-label="digital ' + i + ' year" name="properties[ digital-' + i + ' ][ year ]" placeholder="YYYY" maxLength="4" class="p-3.5 inline-block text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 w-[100px] mr-3.5 digital-customizer-input js-date-input js-year-input text-input text-center" min="1800" oninput="this.value=this.value.slice(0,this.maxLength)" value="' + year + '"/>' +
						'<label for="digital-' + i + '-month" style="opacity:0;font-size:0;margin:0">digital Month</label>' +
						'<input id="digital-' + i + '-month" type="number" aria-label="digital ' + i + ' month" name="properties[ digital-' + i + ' ][ month ]" placeholder="MM" min="1" max="12" maxLength="2" class="p-3.5 inline-block text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 w-[75px] mr-3.5 digital-customizer-input js-date-input js-month-input text-input text-center" maxLength="2" oninput="this.value=this.value.slice(0,this.maxLength)" value="' + month + '"/>' +
						'<label for="digital-' + i + '-day" style="opacity:0;font-size:0;margin:0">digital Day</label>' +
						'<input id="digital-' + i + '-day" type="number" aria-label="digital ' + i + ' day" name="properties[ digital-' + i + ' ][ day ]" placeholder="DD" maxLength="2" class="p-3.5 inline-block text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 w-[75px] mr-3.5 digital-customizer-input js-date-input js-day-input text-input text-center" max="31" min="1" oninput="this.value=this.value.slice(0,this.maxLength)" value="' + day + '"/>' +
						'</div>' +
						'</div>'
					);

				} else {

					$( '.off-canvas-digital-customizer-inputs' ).append(
						'<div class="digital-customizer-single-form ' + ( i === 0 ? '' : 'hidden' ) + '" id="digital-customizer-form-' + i + '">' +
						'<div class="flex items-center mb-2.5">' +
						'<label for="digital-' + i + '-title" class="text-xl font-medium mr-1 text-black">Album Title</label>' +
						'<div class="tooltip">' +
						'<div class="tooltip-icon" tabindex="0"><svg width="20" height="21" viewBox="0 0 20 21"><circle cx="10" cy="10.7981" r="10" fill="#4784F2"/><path d="M9.10258 15.0855V16.7505H10.7676V15.0855H9.10258ZM6.65758 9.38549H7.93258C7.93258 9.03549 7.97258 8.71049 8.05258 8.41049C8.13258 8.11049 8.25758 7.85049 8.42758 7.63049C8.60758 7.41049 8.82758 7.23549 9.08758 7.10549C9.34758 6.97549 9.65758 6.91049 10.0176 6.91049C10.5576 6.91049 10.9826 7.06549 11.2926 7.37549C11.6126 7.68549 11.7926 8.11549 11.8326 8.66549C11.8526 9.03549 11.8076 9.35049 11.6976 9.61049C11.5876 9.87049 11.4376 10.1105 11.2476 10.3305C11.0676 10.5405 10.8676 10.7455 10.6476 10.9455C10.4376 11.1355 10.2326 11.3455 10.0326 11.5755C9.84258 11.8055 9.67758 12.0705 9.53758 12.3705C9.40758 12.6605 9.33258 13.0155 9.31258 13.4355V14.1405H10.5876V13.5555C10.5876 13.2955 10.6226 13.0655 10.6926 12.8655C10.7726 12.6555 10.8726 12.4655 10.9926 12.2955C11.1226 12.1155 11.2626 11.9505 11.4126 11.8005C11.5726 11.6405 11.7326 11.4855 11.8926 11.3355C12.0526 11.1755 12.2076 11.0105 12.3576 10.8405C12.5176 10.6705 12.6576 10.4855 12.7776 10.2855C12.8976 10.0855 12.9926 9.86549 13.0626 9.62549C13.1426 9.37549 13.1826 9.09549 13.1826 8.78549C13.1826 8.30549 13.1026 7.88049 12.9426 7.51049C12.7926 7.14049 12.5776 6.83049 12.2976 6.58049C12.0176 6.32049 11.6826 6.12549 11.2926 5.99549C10.9126 5.85549 10.4876 5.78549 10.0176 5.78549C9.49758 5.78549 9.02758 5.87549 8.60758 6.05549C8.18758 6.23549 7.83258 6.49049 7.54258 6.82049C7.25258 7.14049 7.02758 7.52049 6.86758 7.96049C6.71758 8.40049 6.64758 8.87549 6.65758 9.38549Z" fill="white"/></svg></div> <div class="tooltip-content">' + window.theme.tooltips.album_title + '</div>' +
						'</div>' +
						'</div>' +
						'<input id="digital-' + i + '-title" type="text" aria-label="digital ' + i + ' title" name="properties[ digital-' + i + ' ][ title ]" placeholder="ex. “My Family Memories 1964”" class="p-3.5 w-full text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 title-input digital-customizer-input" maxLength="35" />' +
						'<div class="flex items-center mb-2.5">' +
						'<label class="text-xl font-medium mr-1 text-black">Estimated Media Date</label>' +
						'<div class="tooltip">' +
						'<div class="tooltip-icon" tabindex="0"><svg width="20" height="21" viewBox="0 0 20 21"><circle cx="10" cy="10.7981" r="10" fill="#4784F2"/><path d="M9.10258 15.0855V16.7505H10.7676V15.0855H9.10258ZM6.65758 9.38549H7.93258C7.93258 9.03549 7.97258 8.71049 8.05258 8.41049C8.13258 8.11049 8.25758 7.85049 8.42758 7.63049C8.60758 7.41049 8.82758 7.23549 9.08758 7.10549C9.34758 6.97549 9.65758 6.91049 10.0176 6.91049C10.5576 6.91049 10.9826 7.06549 11.2926 7.37549C11.6126 7.68549 11.7926 8.11549 11.8326 8.66549C11.8526 9.03549 11.8076 9.35049 11.6976 9.61049C11.5876 9.87049 11.4376 10.1105 11.2476 10.3305C11.0676 10.5405 10.8676 10.7455 10.6476 10.9455C10.4376 11.1355 10.2326 11.3455 10.0326 11.5755C9.84258 11.8055 9.67758 12.0705 9.53758 12.3705C9.40758 12.6605 9.33258 13.0155 9.31258 13.4355V14.1405H10.5876V13.5555C10.5876 13.2955 10.6226 13.0655 10.6926 12.8655C10.7726 12.6555 10.8726 12.4655 10.9926 12.2955C11.1226 12.1155 11.2626 11.9505 11.4126 11.8005C11.5726 11.6405 11.7326 11.4855 11.8926 11.3355C12.0526 11.1755 12.2076 11.0105 12.3576 10.8405C12.5176 10.6705 12.6576 10.4855 12.7776 10.2855C12.8976 10.0855 12.9926 9.86549 13.0626 9.62549C13.1426 9.37549 13.1826 9.09549 13.1826 8.78549C13.1826 8.30549 13.1026 7.88049 12.9426 7.51049C12.7926 7.14049 12.5776 6.83049 12.2976 6.58049C12.0176 6.32049 11.6826 6.12549 11.2926 5.99549C10.9126 5.85549 10.4876 5.78549 10.0176 5.78549C9.49758 5.78549 9.02758 5.87549 8.60758 6.05549C8.18758 6.23549 7.83258 6.49049 7.54258 6.82049C7.25258 7.14049 7.02758 7.52049 6.86758 7.96049C6.71758 8.40049 6.64758 8.87549 6.65758 9.38549Z" fill="white"/></svg></div> <div class="tooltip-content date">' + window.theme.tooltips.estimated_date + '</div>' +
						'</div>' +
						'</div>' +
						'<div class="flex items-center">' +
						'<input id="digital-' + i + '-year" type="number" aria-label="digital ' + i + ' year" name="properties[ digital-' + i + ' ][ year ]" placeholder="YYYY" maxLength="4" class="p-3.5 inline-block text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 w-[100px] mr-3.5 digital-customizer-input js-date-input js-year-input text-input text-center" min="1800" oninput="this.value=this.value.slice(0,this.maxLength)"/>' +
						'<input id="digital-' + i + '-month" type="number" aria-label="digital ' + i + ' month" name="properties[ digital-' + i + ' ][ month ]" placeholder="MM" min="1" max="12" maxLength="2" class="p-3.5 inline-block text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 w-[75px] mr-3.5 digital-customizer-input js-date-input js-month-input text-input text-center" maxLength="2" oninput="this.value=this.value.slice(0,this.maxLength)"/>' +
						'<input id="digital-' + i + '-day" type="number" aria-label="digital ' + i + ' day" name="properties[ digital-' + i + ' ][ day ]" placeholder="DD" maxLength="2" class="p-3.5 inline-block text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 w-[75px] mr-3.5 digital-customizer-input js-date-input js-day-input text-input text-center" max="31" min="1" oninput="this.value=this.value.slice(0,this.maxLength)"/>' +
						'</div>' +
						'</div>'
					);

				}

			} else {

				$( '.off-canvas-digital-customizer-inputs' ).append(
					'<div class="digital-customizer-single-form ' + ( i === 0 ? '' : 'hidden' ) + '" id="digital-customizer-form-' + i + '">' +
					'<div class="flex items-center mb-2.5">' +
					'<label for="digital-' + i + '-title" class="text-xl font-medium mr-1 text-black">Album Title</label>' +
					'<div class="tooltip">' +
					'<div class="tooltip-icon" tabindex="0"><svg width="20" height="21" viewBox="0 0 20 21"><circle cx="10" cy="10.7981" r="10" fill="#4784F2"/><path d="M9.10258 15.0855V16.7505H10.7676V15.0855H9.10258ZM6.65758 9.38549H7.93258C7.93258 9.03549 7.97258 8.71049 8.05258 8.41049C8.13258 8.11049 8.25758 7.85049 8.42758 7.63049C8.60758 7.41049 8.82758 7.23549 9.08758 7.10549C9.34758 6.97549 9.65758 6.91049 10.0176 6.91049C10.5576 6.91049 10.9826 7.06549 11.2926 7.37549C11.6126 7.68549 11.7926 8.11549 11.8326 8.66549C11.8526 9.03549 11.8076 9.35049 11.6976 9.61049C11.5876 9.87049 11.4376 10.1105 11.2476 10.3305C11.0676 10.5405 10.8676 10.7455 10.6476 10.9455C10.4376 11.1355 10.2326 11.3455 10.0326 11.5755C9.84258 11.8055 9.67758 12.0705 9.53758 12.3705C9.40758 12.6605 9.33258 13.0155 9.31258 13.4355V14.1405H10.5876V13.5555C10.5876 13.2955 10.6226 13.0655 10.6926 12.8655C10.7726 12.6555 10.8726 12.4655 10.9926 12.2955C11.1226 12.1155 11.2626 11.9505 11.4126 11.8005C11.5726 11.6405 11.7326 11.4855 11.8926 11.3355C12.0526 11.1755 12.2076 11.0105 12.3576 10.8405C12.5176 10.6705 12.6576 10.4855 12.7776 10.2855C12.8976 10.0855 12.9926 9.86549 13.0626 9.62549C13.1426 9.37549 13.1826 9.09549 13.1826 8.78549C13.1826 8.30549 13.1026 7.88049 12.9426 7.51049C12.7926 7.14049 12.5776 6.83049 12.2976 6.58049C12.0176 6.32049 11.6826 6.12549 11.2926 5.99549C10.9126 5.85549 10.4876 5.78549 10.0176 5.78549C9.49758 5.78549 9.02758 5.87549 8.60758 6.05549C8.18758 6.23549 7.83258 6.49049 7.54258 6.82049C7.25258 7.14049 7.02758 7.52049 6.86758 7.96049C6.71758 8.40049 6.64758 8.87549 6.65758 9.38549Z" fill="white"/></svg></div> <div class="tooltip-content">' + window.theme.tooltips.album_title + '</div>' +
					'</div>' +
					'</div>' +
					'<input id="digital-' + i + '-title" type="text" aria-label="digital ' + i + ' title" name="properties[ digital-' + i + ' ][ title ]" placeholder="ex. “My Family Memories 1964”" class="p-3.5 w-full text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 title-input digital-customizer-input" maxLength="35" />' +
					'<div class="flex items-center mb-2.5">' +
					'<label class="text-xl font-medium mr-1 text-black">Estimated Media Date</label>' +
					'<div class="tooltip">' +
					'<div class="tooltip-icon" tabindex="0"><svg width="20" height="21" viewBox="0 0 20 21"><circle cx="10" cy="10.7981" r="10" fill="#4784F2"/><path d="M9.10258 15.0855V16.7505H10.7676V15.0855H9.10258ZM6.65758 9.38549H7.93258C7.93258 9.03549 7.97258 8.71049 8.05258 8.41049C8.13258 8.11049 8.25758 7.85049 8.42758 7.63049C8.60758 7.41049 8.82758 7.23549 9.08758 7.10549C9.34758 6.97549 9.65758 6.91049 10.0176 6.91049C10.5576 6.91049 10.9826 7.06549 11.2926 7.37549C11.6126 7.68549 11.7926 8.11549 11.8326 8.66549C11.8526 9.03549 11.8076 9.35049 11.6976 9.61049C11.5876 9.87049 11.4376 10.1105 11.2476 10.3305C11.0676 10.5405 10.8676 10.7455 10.6476 10.9455C10.4376 11.1355 10.2326 11.3455 10.0326 11.5755C9.84258 11.8055 9.67758 12.0705 9.53758 12.3705C9.40758 12.6605 9.33258 13.0155 9.31258 13.4355V14.1405H10.5876V13.5555C10.5876 13.2955 10.6226 13.0655 10.6926 12.8655C10.7726 12.6555 10.8726 12.4655 10.9926 12.2955C11.1226 12.1155 11.2626 11.9505 11.4126 11.8005C11.5726 11.6405 11.7326 11.4855 11.8926 11.3355C12.0526 11.1755 12.2076 11.0105 12.3576 10.8405C12.5176 10.6705 12.6576 10.4855 12.7776 10.2855C12.8976 10.0855 12.9926 9.86549 13.0626 9.62549C13.1426 9.37549 13.1826 9.09549 13.1826 8.78549C13.1826 8.30549 13.1026 7.88049 12.9426 7.51049C12.7926 7.14049 12.5776 6.83049 12.2976 6.58049C12.0176 6.32049 11.6826 6.12549 11.2926 5.99549C10.9126 5.85549 10.4876 5.78549 10.0176 5.78549C9.49758 5.78549 9.02758 5.87549 8.60758 6.05549C8.18758 6.23549 7.83258 6.49049 7.54258 6.82049C7.25258 7.14049 7.02758 7.52049 6.86758 7.96049C6.71758 8.40049 6.64758 8.87549 6.65758 9.38549Z" fill="white"/></svg></div> <div class="tooltip-content date">' + window.theme.tooltips.estimated_date + '</div>' +
					'</div>' +
					'</div>' +
					'<div class="flex items-center">' +
					'<input id="digital-' + i + '-year" type="number" aria-label="digital ' + i + ' year" name="properties[ digital-' + i + ' ][ year ]" placeholder="YYYY" maxLength="4" class="p-3.5 inline-block text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 w-[100px] mr-3.5 digital-customizer-input js-date-input js-year-input text-input text-center" min="1800" oninput="this.value=this.value.slice(0,this.maxLength)"/>' +
					'<input id="digital-' + i + '-month" type="number" aria-label="digital ' + i + ' month" name="properties[ digital-' + i + ' ][ month ]" placeholder="MM" min="1" max="12" maxLength="2" class="p-3.5 inline-block text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 w-[75px] mr-3.5 digital-customizer-input js-date-input js-month-input text-input text-center" maxLength="2" oninput="this.value=this.value.slice(0,this.maxLength)"/>' +
					'<input id="digital-' + i + '-day" type="number" aria-label="digital ' + i + ' day" name="properties[ digital-' + i + ' ][ day ]" placeholder="DD" maxLength="2" class="p-3.5 inline-block text-base font-roboto placeholder:text-gray-placeholder border-gray-google-dark rounded-sm leading-none mb-8 w-[75px] mr-3.5 digital-customizer-input js-date-input js-day-input text-input text-center" max="31" min="1" oninput="this.value=this.value.slice(0,this.maxLength)"/>' +
					'</div>' +
					'</div>'
				);

			}

		}

		//render pagination
		if( $( 'input[name="quantity"]' ).val() > 1 ) {

			$( '.off-canvas-digital-customizer-actions' ).append(
				'<button type="button" data-page="1" class="js-next-digital button button-blue text-sm mr-3.5 mb-5">Next Media</button>' +
				'<button type="button" data-type="digital_media"  class="js-submit-customizations-digital js-save-media-details button button-blue-outline text-sm mr-3.5 mb-5">Save & Continue</button>'
			);

			$( '.js-next-digital' ).data( 'page', '1' );

			$( '.off-canvas-digital-customizer-actions' ).removeClass( 'final-digital' );

			if( $( '.js-previous-digital' ) ) {

				$( '.js-previous-digital' ).html( 'Next Media' );
				$( '.js-previous-digital' ).data( 'page', '1' );
				$( '.js-previous-digital' ).addClass( 'js-next-digital' );
				$( '.js-next-digital' ).removeClass( 'js-previous-digital' );

			}

		} else {

			$( '.off-canvas-digital-customizer-actions' ).append(
				'<button type="button" data-type="digital_media" class="js-submit-customizations-digital js-save-media-details button button-blue-outline text-sm mr-3.5 mb-5">Save & Continue</button>'
			);

		}

		//ensure all year inputs have a max value of the current year
		var currentYearString = new Date().getFullYear();
		var currentYearInt = parseInt( currentYearString );

		$( '.js-year-input' ).each( function() {

			$( this ).attr( { 'max' : currentYearInt } );

		});

	};

	$( '.js-add-to-cart-digital' ).on( 'click', function( e ) {

		triggerDigitalCustomizer();

	});

	$( document ).on( 'click', '.js-next-digital', function() {

		let target = $( this ).data( 'page' );

		$( '.digital-customizer-select' ).each( function() {

			$( this ).removeClass( 'active' );

		});

		$( '.digital-customizer-single-form' ).each( function() {

			if( ! $( this ).hasClass( 'hidden' ) ) {

				$( this ).addClass( 'hidden' );

			}

		});

		$( '#digital-customizer-form-' + target ).removeClass( 'hidden' );
		$( '#digital-customizer-form-' + target + ' .digital-customizer-input' )[ 0 ].focus();

		if( $( '#digital-' + target ).prop( 'disabled', true ) ) {

			$( '#digital-' + target ).prop( 'disabled', false );
		}

		$( '#digital-' + target ).addClass( 'active' );

		$( '.js-next-digital' ).data( 'page', parseInt( target ) + 1 );

		if( ( parseInt( $( '.js-next-digital' ).data( 'page' ) ) > ( $( 'input[name="quantity"]' ).val() - 1 ) ) ) {

			$( '.off-canvas-digital-customizer-actions' ).addClass( 'final-digital' );

			$( '.js-next-digital' ).html( 'Back to Media 1' );

			$( '.js-next-digital' ).addClass( 'js-previous-digital button-blue-outline' );
			$( '.js-next-digital' ).addClass( 'button-blue-outline' );
			$( '.js-next-digital' ).removeClass( 'button-blue' );
			$( '.js-next-digital' ).removeClass( 'js-next-digital' );

			$( '.js-submit-customizations-digital' ).removeClass( 'button-blue-outline' );
			$( '.js-submit-customizations-digital' ).addClass( 'button-blue' );

		} else {

			$( '.js-previous-digital' ).html( 'Next Media' );

			$( '.js-previous-digital' ).addClass( 'js-next-digital' );
			$( '.js-previous-digital' ).addClass( 'button-blue' );
			$( '.js-previous-digital' ).removeClass( 'button-blue-outline' );
			$( '.js-previous-digital' ).removeClass( 'js-previous-digital' );

			$( '.js-submit-customizations-digital' ).addClass( 'button-blue-outline' );
			$( '.js-submit-customizations-digital' ).removeClass( 'button-blue' );

		}

	});

	$( document ).on( 'click', '.js-previous-digital', function() {

		$( '.digital-customizer-select' ).each( function() {

			$( this ).removeClass( 'active' );

		});

		var firstSelect = $( '.digital-customizer-select' )[ 0 ];

		$( firstSelect ).addClass( 'active' );

		$( '.digital-customizer-single-form' ).each( function() {

			if( ! $( this ).hasClass( 'hidden' ) ) {

				$( this ).addClass( 'hidden' );

			}

		});

		$( '#digital-0' ).removeClass( 'hidden' );
		$( '#digital-customizer-form-0' ).removeClass( 'hidden' );
		$( '#digital-customizer-form-0 .digital-customizer-input' )[ 0 ].focus();

		$( '.off-canvas-digital-customizer-actions' ).removeClass( 'final-digital' );

		$( '.js-previous-digital' ).html( 'Next Media' );

		$( '.js-previous-digital' ).data( 'page', '1' );

		$( '.js-previous-digital' ).addClass( 'js-next-digital' );
		$( '.js-previous-digital' ).addClass( 'button-blue' );
		$( '.js-previous-digital' ).removeClass( 'button-blue-outline' );
		$( '.js-previous-digital' ).removeClass( 'js-previous-digital' );

		$( '.js-submit-customizations-digital' ).addClass( 'button-blue-outline' );
		$( '.js-submit-customizations-digital' ).removeClass( 'button-blue' );

	});

	$( document ).on( 'click', '.digital-customizer-select', function() {

		$( '.digital-customizer-select' ).each( function() {

			$( this ).removeClass( 'active' );

		});

		$( this ).addClass( 'active' );

		let target = $( this ).attr( 'id' ).split( '-' )[ 1 ];

		if( parseInt( target ) + 1 >= $( '.digital-customizer-select' ).length ) {

			$( '.digital-customizer-single-form' ).each( function() {

				if( ! $( this ).hasClass( 'hidden' ) ) {

					$( this ).addClass( 'hidden' );

				}

			});

			$( '#digital-customizer-form-' + target ).removeClass( 'hidden' );

			$( '.js-next-digital' ).html( 'Back to Media 1' );

			$( '.js-next-digital' ).addClass( 'js-previous-digital' );
			$( '.js-next-digital' ).addClass( 'button-blue-outline' );
			$( '.js-next-digital' ).removeClass( 'button-blue' );
			$( '.js-next-digital' ).removeClass( 'js-next-digital' );

			$( '.js-submit-customizations-digital' ).removeClass( 'button-blue-outline' );
			$( '.js-submit-customizations-digital' ).addClass( 'button-blue' );

		} else {

			$( '.digital-customizer-single-form' ).each( function() {

				if( ! $( this ).hasClass( 'hidden' ) ) {

					$( this ).addClass( 'hidden' );

				}

			});

			$( '#digital-customizer-form-' + target ).removeClass( 'hidden' );

			$( '.js-next-digital' ).data( 'page', parseInt( target ) + 1 );

			$( '.js-previous-digital' ).html( 'Next Media' );

			$( '.js-previous-digital' ).data( 'page', parseInt( target ) + 1 );

			$( '.js-previous-digital' ).addClass( 'js-next-digital' );
			$( '.js-previous-digital' ).addClass( 'button-blue' );
			$( '.js-previous-digital' ).removeClass( 'button-blue-outline' );
			$( '.js-previous-digital' ).removeClass( 'js-previous-digital' );

			$( '.js-submit-customizations-digital' ).addClass( 'button-blue-outline' );
			$( '.js-submit-customizations-digital' ).removeClass( 'button-blue' );

		}

	});

})();
